import ErrorOutlineSVG from './errorOutline.svg';
import withIconProps from './withIconProps';

import AttentionSVG from './attention.svg';
import CheckmarkSVG from './checkmark.svg';
import CloseSVG from './close.svg';
import ActivityBoatFilledSVG from './icon_activity_boat_filled.svg';
import ActivityDivingFilledSVG from './icon_activity_diving_filled.svg';
import ActivityFishingFilledSVG from './icon_activity_fishing_filled.svg';
import ActivityGolfFilledSVG from './icon_activity_golf_filled.svg';
import ActivityMassageFilledSVG from './icon_activity_massage_filled.svg';
import ActivityParachuteFilledSVG from './icon_activity_parachute_filled.svg';
import ActivityPotteryFilledSVG from './icon_activity_pottery_filled.svg';
import ActivityRowingFilledSVG from './icon_activity_rowing_filled.svg';
import ActivitySkiFilledSVG from './icon_activity_ski_filled.svg';
import ActivitySnowboardFilledSVG from './icon_activity_snowboard_filled.svg';
import ActivitySurfingFilledSVG from './icon_activity_surfing_filled.svg';
import ActivityTrekkingFilledSVG from './icon_activity_trekking_filled.svg';
import AddMediaFilledSVG from './icon_add_media_filled.svg';
import AddMediaOutlineSVG from './icon_add_media_outline.svg';
import AddOnFilledSVG from './icon_add_on_filled.svg';
import AiSuggestionShineFilledSVG from './icon_ai_suggestion_shine_filled.svg';
import AlertColoredOutlinedSVG from './icon_alert_colored_outlined.svg';
import AlertRexFilledSVG from './icon_alert_rex_filled.svg';
import AmenitiesAdapterFilledSVG from './icon_amenities_adapter_filled.svg';
import AmenitiesAirConditionerFilledSVG from './icon_amenities_air_conditioner_filled.svg';
import AmenitiesAirPurifierFilledSVG from './icon_amenities_air_purifier_filled.svg';
import AmenitiesBathTowelFilledSVG from './icon_amenities_bath_towel_filled.svg';
import AmenitiesBottleWaterFilledSVG from './icon_amenities_bottle_water_filled.svg';
import AmenitiesClosetFilledSVG from './icon_amenities_closet_filled.svg';
import AmenitiesDeskFilledSVG from './icon_amenities_desk_filled.svg';
import AmenitiesDressCodeFilledSVG from './icon_amenities_dress_code_filled.svg';
import AmenitiesDryCleaningFilledSVG from './icon_amenities_dry_cleaning_filled.svg';
import AmenitiesDvdFilledSVG from './icon_amenities_dvd_filled.svg';
import AmenitiesFanFilledSVG from './icon_amenities_fan_filled.svg';
import AmenitiesHairDryerFilledSVG from './icon_amenities_hair_dryer_filled.svg';
import AmenitiesIronFilledSVG from './icon_amenities_iron_filled.svg';
import AmenitiesLightbulbFilledSVG from './icon_amenities_lightbulb_filled.svg';
import AmenitiesLockerFilledSVG from './icon_amenities_locker_filled.svg';
import AmenitiesLuggageFilledSVG from './icon_amenities_luggage_filled.svg';
import AmenitiesMicrowaveFilledSVG from './icon_amenities_microwave_filled.svg';
import AmenitiesPocketWifiFilledSVG from './icon_amenities_pocket_wifi_filled.svg';
import AmenitiesPowerOutletFilledSVG from './icon_amenities_power_outlet_filled.svg';
import AmenitiesRefrigeratorFilledSVG from './icon_amenities_refrigerator_filled.svg';
import AmenitiesRoomWifiFilledSVG from './icon_amenities_room_wifi_filled.svg';
import AmenitiesSafeFilledSVG from './icon_amenities_safe_filled.svg';
import AmenitiesSoapAndShampooFilledSVG from './icon_amenities_soap_and_shampoo_filled.svg';
import AmenitiesSprayFilledSVG from './icon_amenities_spray_filled.svg';
import AmenitiesTelevisionTvFilledSVG from './icon_amenities_television_tv_filled.svg';
import AmenitiesTrouserPresserFilledSVG from './icon_amenities_trouser_presser_filled.svg';
import AmenitiesWashingMachineFilledSVG from './icon_amenities_washing_machine_filled.svg';
import AmenitiesWasteFilledSVG from './icon_amenities_waste_filled.svg';
import AmenitiesWifiFilledSVG from './icon_amenities_wifi_filled.svg';
import AmenitiesWiredInternetFilledSVG from './icon_amenities_wired_internet_filled.svg';
import AmenitiesYukataFilledSVG from './icon_amenities_yukata_filled.svg';
import ArchiveDeleteInboundIsUsingFilledSVG from './icon_archive__delete_inbound_is_using_filled.svg';
import AreaSearchFilledSVG from './icon_area_search_filled.svg';
import ArrowCircleChevronDownFilledSVG from './icon_arrow_circle_chevron_down_filled.svg';
import ArrowCircleChevronLeftFilledSVG from './icon_arrow_circle_chevron_left_filled.svg';
import ArrowCircleChevronRightFilledSVG from './icon_arrow_circle_chevron_right_filled.svg';
import ArrowCircleChevronUpFilledSVG from './icon_arrow_circle_chevron_up_filled.svg';
import ArrowCircleDownFilledSVG from './icon_arrow_circle_down_filled.svg';
import ArrowCircleDownOutlineSVG from './icon_arrow_circle_down_outline.svg';
import ArrowCircleLeftFilledSVG from './icon_arrow_circle_left_filled.svg';
import ArrowCircleLeftOutlineSVG from './icon_arrow_circle_left_outline.svg';
import ArrowCircleRightFilledSVG from './icon_arrow_circle_right_filled.svg';
import ArrowCircleRightOutlineSVG from './icon_arrow_circle_right_outline.svg';
import ArrowCircleUpFilledSVG from './icon_arrow_circle_up_filled.svg';
import ArrowCircleUpOutlineSVG from './icon_arrow_circle_up_outline.svg';
import ArrowLongDownFilledSVG from './icon_arrow_long_down_filled.svg';
import ArrowLongLeftFilledSVG from './icon_arrow_long_left_filled.svg';
import ArrowLongRightFilledSVG from './icon_arrow_long_right_filled.svg';
import ArrowLongUpFilledSVG from './icon_arrow_long_up_filled.svg';
import ArrowShapeDownFilledSVG from './icon_arrow_shape_down_filled.svg';
import ArrowShapeLeftFilledSVG from './icon_arrow_shape_left_filled.svg';
import ArrowShapeRightFilledSVG from './icon_arrow_shape_right_filled.svg';
import ArrowShapeUpFilledSVG from './icon_arrow_shape_up__filled.svg';
import AspectRatioOutlineSVG from './icon_aspect_ratio_outline.svg';
import AwardFilledSVG from './icon_award_filled.svg';
import BackwardFilledSVG from './icon_backward_filled.svg';
import BanRexFilledSVG from './icon_ban_rex_filled.svg';
import BanRexOutlineSVG from './icon_ban_rex_outline.svg';
import BarcodeRexFilledSVG from './icon_barcode_rex_filled.svg';
import BarcodeRexOutlineSVG from './icon_barcode_rex_outline.svg';
import BeachFilledSVG from './icon_beach_filled.svg';
import BedBabyCribFilledSVG from './icon_bed_baby_crib_filled.svg';
import BedBunkBedFilledSVG from './icon_bed_bunk_bed_filled.svg';
import BedDoubleBedFilledSVG from './icon_bed_double_bed_filled.svg';
import BedExtraBedFilledSVG from './icon_bed_extra_bed_filled.svg';
import BedFutonFilledSVG from './icon_bed_futon_filled.svg';
import BedLoftBedFilledSVG from './icon_bed_loft_bed_filled.svg';
import BedNoBedFilledSVG from './icon_bed_no_bed_filled.svg';
import BedRoomSingleBedFilledSVG from './icon_bed_room_single_bed_filled.svg';
import BedShareBedFilledSVG from './icon_bed_share_bed_filled.svg';
import BedSofaBedFilledSVG from './icon_bed_sofa_bed_filled.svg';
import BedSuiteSpecialLuxuryFilledSVG from './icon_bed_suite_special_luxury_filled.svg';
import BedTripleBedFilledSVG from './icon_bed_triple_bed_filled.svg';
import BedTwinBedFilledSVG from './icon_bed_twin_bed_filled.svg';
import BowFilledSVG from './icon_bow_filled.svg';
import BrowsingHistoryRexFilledSVG from './icon_browsing_history_rex_filled.svg';
import BrowsingHistoryRexOutlineSVG from './icon_browsing_history_rex_outline.svg';
import BuildingRexFilledSVG from './icon_building_rex_filled.svg';
import BuildingRexOutlineSVG from './icon_building_rex_outline.svg';
import BusinessHotelFilledSVG from './icon_business_hotel_filled.svg';
import CalculatorRexFilledSVG from './icon_calculator_rex_filled.svg';
import CalculatorRexOutlineSVG from './icon_calculator_rex_outline.svg';
import CalendarAddCalendarFilledSVG from './icon_calendar_add_calendar_filled.svg';
import CalendarAnniversaryFilledSVG from './icon_calendar_anniversary_filled.svg';
import CalendarCancelFilledSVG from './icon_calendar_cancel_filled.svg';
import CalendarChangeFilledSVG from './icon_calendar_change_filled.svg';
import CalendarFailFilledSVG from './icon_calendar_fail_filled.svg';
import CalendarRexFilledSVG from './icon_calendar_rex_filled.svg';
import CalendarRexOutlineSVG from './icon_calendar_rex_outline.svg';
import CalendarSpecialFilledSVG from './icon_calendar_special_filled.svg';
import CalendarSucceedFilledSVG from './icon_calendar_succeed_filled.svg';
import CalendarVacancyFilledSVG from './icon_calendar_vacancy_filled.svg';
import CameraRexFilledSVG from './icon_camera_rex_filled.svg';
import CameraRexOutlineSVG from './icon_camera_rex_outline.svg';
import CheckCircleFilledSVG from './icon_check_circle_filled.svg';
import CheckCircleOutlineSVG from './icon_check_circle_outline.svg';
import CheckFilledSVG from './icon_check_filled.svg';
import ChevronBoldDownFilledSVG from './icon_chevron_bold_down_filled.svg';
import ChevronBoldLeftFilledSVG from './icon_chevron_bold_left_filled.svg';
import ChevronBoldRightFilledSVG from './icon_chevron_bold_right_filled.svg';
import ChevronBoldUpFilledSVG from './icon_chevron_bold_up_filled.svg';
import ChevronRegularDownFilledSVG from './icon_chevron_regular_down_filled.svg';
import ChevronRegularLeftFilledSVG from './icon_chevron_regular_left_filled.svg';
import ChevronRegularRightFilledSVG from './icon_chevron_regular_right_filled.svg';
import ChevronRegularUpFilledSVG from './icon_chevron_regular_up_filled.svg';
import ClearFilledSVG from './icon_clear_filled.svg';
import CloseFilledSVG from './icon_close_filled.svg';
import CloseOutlineSVG from './icon_close_outline.svg';
import CloudRexFilledSVG from './icon_cloud_rex_filled.svg';
import CloudRexOutlineSVG from './icon_cloud_rex_outline.svg';
import CommentRexFilledSVG from './icon_comment_rex_filled.svg';
import CommentRexOutlineSVG from './icon_comment_rex_outline.svg';
import CompareRexFilledSVG from './icon_compare_rex_filled.svg';
import CompareRexOutlineSVG from './icon_compare_rex_outline.svg';
import CopyFilledSVG from './icon_copy_filled.svg';
import CopyrightOutlineSVG from './icon_copyright_outline.svg';
import CreditCardAmericanExpressSVG from './icon_credit_card_american_express.svg';
import CreditCardAmericanExpressBackCvvSVG from './icon_credit_card_american_express_back_cvv.svg';
import CreditCardBackCvvSVG from './icon_credit_card_back_cvv.svg';
import CreditCardCashSVG from './icon_credit_card_cash.svg';
import CreditCardChinaUnionpaySVG from './icon_credit_card_china_unionpay.svg';
import CreditCardDinersSVG from './icon_credit_card_diners.svg';
import CreditCardDiscoverSVG from './icon_credit_card_discover.svg';
import CreditCardJcbSVG from './icon_credit_card_jcb.svg';
import CreditCardMasterCardSVG from './icon_credit_card_master_card.svg';
import CreditCardOtherCreditCardNameSVG from './icon_credit_card_other_credit_card_name.svg';
import CreditCardPlaceholderSVG from './icon_credit_card_placeholder.svg';
import CreditCardVisaSVG from './icon_credit_card_visa.svg';
import CropAndRotateFilledSVG from './icon_crop_and_rotate_filled.svg';
import CropFilledSVG from './icon_crop_filled.svg';
import CrownFilledSVG from './icon_crown_filled.svg';
import CurrentLocationFilledSVG from './icon_current_location_filled.svg';
import CurrentLocationOutlineSVG from './icon_current_location_outline.svg';
import DeleteRexFilledSVG from './icon_delete_rex_filled.svg';
import DeleteRexOutlineSVG from './icon_delete_rex_outline.svg';
import DesktopRexFilledSVG from './icon_desktop_rex_filled.svg';
import DesktopRexOutlineSVG from './icon_desktop_rex_outline.svg';
import DiscussionRexFilledSVG from './icon_discussion_rex_filled.svg';
import DiscussionRexOutlineSVG from './icon_discussion_rex_outline.svg';
import DiversityFilledSVG from './icon_diversity_filled.svg';
import DocumentFormRexFilledSVG from './icon_document_form_rex_filled.svg';
import DocumentFormRexOutlineSVG from './icon_document_form_rex_outline.svg';
import DomesticMapRexFilledSVG from './icon_domestic_map_rex_filled.svg';
import DomesticMapRexOutlineSVG from './icon_domestic_map_rex_outline.svg';
import DotFilledSVG from './icon_dot_filled.svg';
import DownloadRexFilledSVG from './icon_download_rex_filled.svg';
import DownloadRexOutlineSVG from './icon_download_rex_outline.svg';
import DynamicPackageFilledSVG from './icon_dynamic_package_filled.svg';
import EditRexFilledSVG from './icon_edit_rex_filled.svg';
import EditRexOutlineSVG from './icon_edit_rex_outline.svg';
import EmergencyFilledSVG from './icon_emergency_filled.svg';
import EmotionHappyFilledSVG from './icon_emotion_happy_filled.svg';
import EmotionLoveFilledSVG from './icon_emotion_love_filled.svg';
import EmotionNeutralFilledSVG from './icon_emotion_neutral_filled.svg';
import EmotionSadFilledSVG from './icon_emotion_sad_filled.svg';
import EmotionSickFilledSVG from './icon_emotion_sick_filled.svg';
import EmotionSurpriseFilledSVG from './icon_emotion_surprise_filled.svg';
import EmotionUnhappyFilledSVG from './icon_emotion_unhappy_filled.svg';
import ErrorColoredOutlinedSVG from './icon_error_colored_outlined.svg';
import ErrorFilledSVG from './icon_error_filled.svg';
import EventBowFilledSVG from './icon_event_bow_filled.svg';
import EventCelebrationFilledSVG from './icon_event_celebration_filled.svg';
import EventPartyFilledSVG from './icon_event_party_filled.svg';
import ExpandFilledSVG from './icon_expand_filled.svg';
import EyeFilledSVG from './icon_eye_filled.svg';
import FacilityAccessibilityFilledSVG from './icon_facility_accessibility_filled.svg';
import FacilityAllinclusiveFilledSVG from './icon_facility_allinclusive_filled.svg';
import FacilityBabysitterFilledSVG from './icon_facility_babysitter_filled.svg';
import FacilityClubLoungeFilledSVG from './icon_facility_club_lounge_filled.svg';
import FacilityCommunalBathFilledSVG from './icon_facility_communal_bath_filled.svg';
import FacilityElevatorFilledSVG from './icon_facility_elevator_filled.svg';
import FacilityGrandBathFilledSVG from './icon_facility_grand_bath_filled.svg';
import FacilityGymFilledSVG from './icon_facility_gym_filled.svg';
import FacilityHotSpringFilledSVG from './icon_facility_hot_spring_filled.svg';
import FacilityIndoorHotSpringFilledSVG from './icon_facility_indoor_hot_spring_filled.svg';
import FacilityJapaneseGardenFilledSVG from './icon_facility_japanese_garden_filled.svg';
import FacilityNoParkingFilledSVG from './icon_facility_no_parking_filled.svg';
import FacilityNursingRoomFilledSVG from './icon_facility_nursing_room_filled.svg';
import FacilityOpenairBathFilledSVG from './icon_facility_openair_bath_filled.svg';
import FacilityParkingFilledSVG from './icon_facility_parking_filled.svg';
import FacilityPetsFilledSVG from './icon_facility_pets_filled.svg';
import FacilityPoolFilledSVG from './icon_facility_pool_filled.svg';
import FacilityPrivateBathFilledSVG from './icon_facility_private_bath_filled.svg';
import FacilitySemiOpenairBathFilledSVG from './icon_facility_semi_openair_bath_filled.svg';
import FacilitySkyLoungeFilledSVG from './icon_facility_sky_lounge_filled.svg';
import FacilityStairsFilledSVG from './icon_facility_stairs_filled.svg';
import FilterRexFilledSVG from './icon_filter_rex_filled.svg';
import FilterRexOutlineSVG from './icon_filter_rex_outline.svg';
import FireworksFilledSVG from './icon_fireworks_filled.svg';
import FlagFilledSVG from './icon_flag_filled.svg';
import FlagOutlineSVG from './icon_flag_outline.svg';
import FolderRexFilledSVG from './icon_folder_rex_filled.svg';
import FolderRexOutlineSVG from './icon_folder_rex_outline.svg';
import FoodBarFilledSVG from './icon_food_bar_filled.svg';
import FoodBbqFilledSVG from './icon_food_bbq_filled.svg';
import FoodBentoFilledSVG from './icon_food_bento_filled.svg';
import FoodBreakfastFilledSVG from './icon_food_breakfast_filled.svg';
import FoodBreakfastVoucherFilledSVG from './icon_food_breakfast_voucher_filled.svg';
import FoodCafeFilledSVG from './icon_food_cafe_filled.svg';
import FoodDinnerFilledSVG from './icon_food_dinner_filled.svg';
import FoodFineDiningFilledSVG from './icon_food_fine_dining_filled.svg';
import FoodHalalFilledSVG from './icon_food_halal_filled.svg';
import FoodInRoomBreakfastFilledSVG from './icon_food_in_room_breakfast_filled.svg';
import FoodLocalCuisineFilledSVG from './icon_food_local_cuisine_filled.svg';
import FoodMealConsiderationFilledSVG from './icon_food_meal_consideration_filled.svg';
import FoodMealFilledSVG from './icon_food_meal_filled.svg';
import FoodNoMealFilledSVG from './icon_food_no_meal_filled.svg';
import FoodPicnicFilledSVG from './icon_food_picnic_filled.svg';
import FoodRoomServiceFilledSVG from './icon_food_room_service_filled.svg';
import FoodUpgradeMealFilledSVG from './icon_food_upgrade_meal_filled.svg';
import FoodVegetarianFilledSVG from './icon_food_vegetarian_filled.svg';
import ForwardFilledSVG from './icon_forward_filled.svg';
import GalleryFilledSVG from './icon_gallery_filled.svg';
import GetCouponFilledSVG from './icon_get_coupon_filled.svg';
import GoldenWeekFilledSVG from './icon_golden_week_filled.svg';
import GrabFilledSVG from './icon_grab_filled.svg';
import GuidebookOutlineSVG from './icon_guidebook_outline.svg';
import HandleFilledSVG from './icon_handle_filled.svg';
import HelpRexFilledSVG from './icon_help_rex_filled.svg';
import HelpRexOutlineSVG from './icon_help_rex_outline.svg';
import HideRexFilledSVG from './icon_hide_rex_filled.svg';
import HideRexOutlineSVG from './icon_hide_rex_outline.svg';
import HomeRexFilledSVG from './icon_home_rex_filled.svg';
import HomeRexOutlineSVG from './icon_home_rex_outline.svg';
import HorizontalDotsFilledSVG from './icon_horizontal_dots_filled.svg';
import HotelAnnexFilledSVG from './icon_hotel_annex_filled.svg';
import HotelCityFilledSVG from './icon_hotel_city_filled.svg';
import HotelGlampingFilledSVG from './icon_hotel_glamping_filled.svg';
import HotelHotelFilledSVG from './icon_hotel_hotel_filled.svg';
import HotelPackageFilledSVG from './icon_hotel_package_filled.svg';
import HotelRyokanFilledSVG from './icon_hotel_ryokan_filled.svg';
import IdentificationDocumentRexFilledSVG from './icon_identification_document_rex_filled.svg';
import IdentificationDocumentRexOutlineSVG from './icon_identification_document_rex_outline.svg';
import ImageBrokenFilledSVG from './icon_image_broken_filled.svg';
import ImageRexFilledSVG from './icon_image_rex_filled.svg';
import ImageRexOutlineSVG from './icon_image_rex_outline.svg';
import InfoColoredOutlinedSvg from './icon_info_colored_outlined.svg';
import InfoRexFilledSVG from './icon_info_rex_filled.svg';
import InfoRexOutlineSVG from './icon_info_rex_outline.svg';
import JapanQualityFilledSVG from './icon_japan_quality_filled.svg';
import KeyboardRexFilledSVG from './icon_keyboard_rex_filled.svg';
import KeyboardRexOutlineSVG from './icon_keyboard_rex_outline.svg';
import LanguageRexFilledSVG from './icon_language_rex_filled.svg';
import LanguageRexOutlineSVG from './icon_language_rex_outline.svg';
import LeafFilledSVG from './icon_leaf_filled.svg';
import LegolandOutlineSVG from './icon_legoland_outline.svg';
import LightModeFilledSVG from './icon_light_mode_filled.svg';
import LikeRexFilledSVG from './icon_like__rex_filled.svg';
import LikeRexOutlineSVG from './icon_like__rex_outline.svg';
import ListRexFilledSVG from './icon_list_rex_filled.svg';
import ListRexOutlineSVG from './icon_list_rex_outline.svg';
import LoadingFilledSVG from './icon_loading_filled.svg';
import LocalContributionFilledSVG from './icon_local_contribution_filled.svg';
import LocationRexFilledSVG from './icon_location_rex_filled.svg';
import LocationRexOutlineSVG from './icon_location_rex_outline.svg';
import LoginFilledSVG from './icon_login_filled.svg';
import LogoutFilledSVG from './icon_logout_filled.svg';
import MagicWandFilledSVG from './icon_magic_wand_filled.svg';
import MailRexFilledSVG from './icon_mail_rex_filled.svg';
import MailRexOutlineSVG from './icon_mail_rex_outline.svg';
import MapRexFilledSVG from './icon_map_rex_filled.svg';
import MapRexOutlineSVG from './icon_map_rex_outline.svg';
import MapleLeafFilledSVG from './icon_maple_leaf_filled.svg';
import MediaRexFilledSVG from './icon_media_rex_filled.svg';
import MediaRexOutlineSVG from './icon_media_rex_outline.svg';
import MenuAccountFilledSVG from './icon_menu_account_filled.svg';
import MenuAccountOutlineSVG from './icon_menu_account_outline.svg';
import MenuCampaign2FilledSVG from './icon_menu_campaign_2_filled.svg';
import MenuCampaign2OutlineSVG from './icon_menu_campaign_2_outline.svg';
import MenuCampaignFilledSVG from './icon_menu_campaign_filled.svg';
import MenuCampaignOutlineSVG from './icon_menu_campaign_outline.svg';
import MenuFavoriteFilledSVG from './icon_menu_favorite_filled.svg';
import MenuFavoriteOutlineSVG from './icon_menu_favorite_outline.svg';
import MenuHomeFilledSVG from './icon_menu_home_filled.svg';
import MenuHomeOutlineSVG from './icon_menu_home_outline.svg';
import MenuOutlineSVG from './icon_menu_outline.svg';
import MenuReservationSuitcaseFilledSVG from './icon_menu_reservation_suitcase_filled.svg';
import MenuReservationSuitcaseOutlineSVG from './icon_menu_reservation_suitcase_outline.svg';
import MenuStarFilledSVG from './icon_menu_star_filled.svg';
import MenuStarHalfFilledSVG from './icon_menu_star_half_filled.svg';
import MenuStarOutlineSVG from './icon_menu_star_outline.svg';
import MidnightFilledSVG from './icon_midnight_filled.svg';
import MinusBoldFilledSVG from './icon_minus_bold_filled.svg';
import MinusInCircleFilledSVG from './icon_minus_in_circle_filled.svg';
import MinusInCircleOutlineSVG from './icon_minus_in_circle_outline.svg';
import MinusInSquareFilledSVG from './icon_minus_in_square_filled.svg';
import MinusRegularFilledSVG from './icon_minus_regular_filled.svg';
import MobileRexFilledSVG from './icon_mobile_rex_filled.svg';
import MobileRexOutlineSVG from './icon_mobile_rex_outline.svg';
import MusicFilledSVG from './icon_music_filled.svg';
import NewPhoneFilledSVG from './icon_new_phone_filled.svg';
import NewUserFilledSVG from './icon_new_user_filled.svg';
import NewWindowRexFilledSVG from './icon_new_window_rex_filled.svg';
import NewWindowRexOutlineSVG from './icon_new_window_rex_outline.svg';
import NewsRexFilledSVG from './icon_news_rex_filled.svg';
import NewsRexOutlineSVG from './icon_news_rex_outline.svg';
import NoticeRexFilledSVG from './icon_notice_rex_filled.svg';
import NoticeRexOutlineSVG from './icon_notice_rex_outline.svg';
import NotificationRexFilledSVG from './icon_notification_rex_filled.svg';
import NotificationRexOutlineSVG from './icon_notification_rex_outline.svg';
import OpenExternalFilledSVG from './icon_open_external_filled.svg';
import OtherInitiativesFilledSVG from './icon_other_initiatives_filled.svg';
import PaintRexFilledSVG from './icon_paint_rex_filled.svg';
import PaintRexOutlineSVG from './icon_paint_rex_outline.svg';
import PamphletFilledSVG from './icon_pamphlet_filled.svg';
import PauseFilledSVG from './icon_pause_filled.svg';
import PauseWithCircleFilledSVG from './icon_pause_with_circle_filled.svg';
import PaymentCashOnlyFilledSVG from './icon_payment_cash_only_filled.svg';
import PaymentCreditCardRexFilledSVG from './icon_payment_credit_card_rex_filled.svg';
import PaymentCreditCardRexOutlineSVG from './icon_payment_credit_card_rex_outline.svg';
import PaymentCurrencyRexFilledSVG from './icon_payment_currency_rex_filled.svg';
import PaymentCurrencyRexOutlineSVG from './icon_payment_currency_rex_outline.svg';
import PaymentElectricMoneyFilledSVG from './icon_payment_electric_money_filled.svg';
import PaymentMethodCardMobileOutlineSVG from './icon_payment_method_card_mobile_outline.svg';
import PaymentMethodMobileFilledSVG from './icon_payment_method_mobile_filled.svg';
import PaymentMethodMobileOutlineSVG from './icon_payment_method_mobile_outline.svg';
import PaymentNoCreditCardFilledSVG from './icon_payment_no_credit_card_filled.svg';
import PaymentNonrefundFilledSVG from './icon_payment_nonrefund_filled.svg';
import PaymentPayOnSiteFilledSVG from './icon_payment_pay_on_site_filled.svg';
import PaymentPaymentMethodFilledSVG from './icon_payment_payment_method_filled.svg';
import PdfRexFilledSVG from './icon_pdf_rex_filled.svg';
import PdfRexOutlineSVG from './icon_pdf_rex_outline.svg';
import PeopleAdultFilledSVG from './icon_people_adult_filled.svg';
import PeopleBabyFilledSVG from './icon_people_baby_filled.svg';
import PeopleChildFilledSVG from './icon_people_child_filled.svg';
import PeopleCloseAccountRexFilledSVG from './icon_people_close_account_rex_filled.svg';
import PeopleCloseAccountRexOutlineSVG from './icon_people_close_account_rex_outline.svg';
import PeopleGroupOfPeopleFilledSVG from './icon_people_group_of_people_filled.svg';
import PeopleManFilledSVG from './icon_people_man_filled.svg';
import PeopleMemberFavoriteFilledSVG from './icon_people_member_favorite_filled.svg';
import PeopleMemberFavoriteOutlineSVG from './icon_people_member_favorite_outline.svg';
import PeopleMyPageRexFilledSVG from './icon_people_my_page_rex_filled.svg';
import PeopleMyPageRexOutlineSVG from './icon_people_my_page_rex_outline.svg';
import PeopleNobabyFilledSVG from './icon_people_nobaby_filled.svg';
import PeopleReception2FilledSVG from './icon_people_reception_2_filled.svg';
import PeopleReception3FilledSVG from './icon_people_reception_3_filled.svg';
import PeopleReceptionFilledSVG from './icon_people_reception_filled.svg';
import PeopleRegisterAccountRexFilledSVG from './icon_people_register_account_rex_filled.svg';
import PeopleRegisterAccountRexOutlineSVG from './icon_people_register_account_rex_outline.svg';
import PeopleStaffFilledSVG from './icon_people_staff_filled.svg';
import PeopleUserRexFilledSVG from './icon_people_user_rex_filled.svg';
import PeopleUserRexOutlineSVG from './icon_people_user_rex_outline.svg';
import PeopleWomanFilledSVG from './icon_people_woman_filled.svg';
import PhoneRexFilledSVG from './icon_phone_rex_filled.svg';
import PhoneRexOutlineSVG from './icon_phone_rex_outline.svg';
import PinRexFilledSVG from './icon_pin_rex_filled.svg';
import PinRexOutlineSVG from './icon_pin_rex_outline.svg';
import PlayFilledSVG from './icon_play_filled.svg';
import PlayWithCircleFilledSVG from './icon_play_with_circle_filled.svg';
import PlusBoldFilledSVG from './icon_plus_bold_filled.svg';
import PlusInCircleFilledSVG from './icon_plus_in_circle_filled.svg';
import PlusInCircleOutlineSVG from './icon_plus_in_circle_outline.svg';
import PlusInSquareFilledSVG from './icon_plus_in_square_filled.svg';
import PlusRegularFilledSVG from './icon_plus_regular_filled.svg';
import PocAtmMachineFilledSVG from './icon_poc_atm_machine_filled.svg';
import PocCampingFilledSVG from './icon_poc_camping_filled.svg';
import PocChurchFilledSVG from './icon_poc_church_filled.svg';
import PocConvenienceStoreFilledSVG from './icon_poc_convenience_store_filled.svg';
import PocFerrisWheelFilledSVG from './icon_poc_ferris_wheel_filled.svg';
import PocGolfFilledSVG from './icon_poc_golf_filled.svg';
import PocKaraokeRoomFilledSVG from './icon_poc_karaoke_room_filled.svg';
import PocMuseumFilledSVG from './icon_poc_museum_filled.svg';
import PocPlaygroundFilledSVG from './icon_poc_playground_filled.svg';
import PocShopRexFilledSVG from './icon_poc_shop_rex_filled.svg';
import PocShopRexOutlineSVG from './icon_poc_shop_rex_outline.svg';
import PocShoppingCartRexFilledSVG from './icon_poc_shopping_cart_rex_filled.svg';
import PocShoppingCartRexOutlineSVG from './icon_poc_shopping_cart_rex_outline.svg';
import PocShoppingFilledSVG from './icon_poc_shopping_filled.svg';
import PocSightseeing2FilledSVG from './icon_poc_sightseeing_2_filled.svg';
import PocSightseeingFilledSVG from './icon_poc_sightseeing_filled.svg';
import PocSunsetFilledSVG from './icon_poc_sunset_filled.svg';
import PocWindMillDutchFilledSVG from './icon_poc_wind_mill_dutch_filled.svg';
import PointBarcodeColorSVG from './icon_point_barcode_color.svg';
import PointBarcodeOutlinedSVG from './icon_point_barcode_outlined.svg';
import PostalCodeFilledSVG from './icon_postal_code_filled.svg';
import PrintRexFilledSVG from './icon_print_rex_filled.svg';
import PrintRexOutlineSVG from './icon_print_rex_outline.svg';
import PromotionBestFilledSVG from './icon_promotion_best_filled.svg';
import PromotionBestOutlineSVG from './icon_promotion_best_outline.svg';
import PromotionBonusProgramFilledSVG from './icon_promotion_bonus_program_filled.svg';
import PromotionBonusProgramOutlineSVG from './icon_promotion_bonus_program_outline.svg';
import PromotionCampaignRexFilledSVG from './icon_promotion_campaign_rex_filled.svg';
import PromotionCampaignRexOutlineSVG from './icon_promotion_campaign_rex_outline.svg';
import PromotionCouponFilledSVG from './icon_promotion_coupon_filled.svg';
import PromotionCouponRexFilledSVG from './icon_promotion_coupon_rex_filled.svg';
import PromotionCouponRexOutlineSVG from './icon_promotion_coupon_rex_outline.svg';
import PromotionEarlyBirdFilledSVG from './icon_promotion_early_bird_filled.svg';
import PromotionGiftFilledSVG from './icon_promotion_gift_filled.svg';
import PromotionMultipleCouponsFilledSVG from './icon_promotion_multiple_coupons_filled.svg';
import PromotionPointRewardRexFilledSVG from './icon_promotion_point_reward_rex_filled.svg';
import PromotionPointRewardRexOutlineSVG from './icon_promotion_point_reward_rex_outline.svg';
import PromotionPointRexFilledSVG from './icon_promotion_point_rex_filled.svg';
import PromotionPointRexOutlineSVG from './icon_promotion_point_rex_outline.svg';
import PromotionTagRexFilledSVG from './icon_promotion_tag_rex_filled.svg';
import PromotionTagRexOutlineSVG from './icon_promotion_tag_rex_outline.svg';
import PromotionTicketRexFilledSVG from './icon_promotion_ticket_rex_filled.svg';
import PromotionTicketRexOutlineSVG from './icon_promotion_ticket_rex_outline.svg';
import ProviderAirlinePlaceholderFilledSVG from './icon_provider_airline_placeholder_filled.svg';
import PurchaseHistoryRexFilledSVG from './icon_purchase_history_rex_filled.svg';
import PurchaseHistoryRexOutlineSVG from './icon_purchase_history_rex_outline.svg';
import QrCodeRexFilledSVG from './icon_qr_code_rex_filled.svg';
import QrCodeRexOutlineSVG from './icon_qr_code_rex_outline.svg';
import RakutenAiFullFilledSVG from './icon_rakuten_ai_full_filled.svg';
import RakutenAiSymbolFilledSVG from './icon_rakuten_ai_symbol_filled.svg';
import RakutenFilledSVG from './icon_rakuten_filled.svg';
import RakutenMobileOutlineSVG from './icon_rakuten_mobile_outline.svg';
import Rank1CrownFilledSVG from './icon_rank_1_crown_filled.svg';
import Rank2CrownFilledSVG from './icon_rank_2_crown_filled.svg';
import Rank3CrownFilledSVG from './icon_rank_3_crown_filled.svg';
import Rank4CrownFilledSVG from './icon_rank_4_crown_filled.svg';
import Rank5CrownFilledSVG from './icon_rank_5_crown_filled.svg';
import RankDiamondNoRibbonDarkModeSVG from './icon_rank_diamond_no_ribbon_dark_mode.svg';
import RankDiamondNoRibbonLightModeSVG from './icon_rank_diamond_no_ribbon_light_mode.svg';
import RankDiamondRibbonDarkModeSVG from './icon_rank_diamond_ribbon_dark_mode.svg';
import RankDiamondRibbonLightModeSVG from './icon_rank_diamond_ribbon_light_mode.svg';
import RankGoldNoRibbonSVG from './icon_rank_gold_no_ribbon.svg';
import RankGoldRibbonSVG from './icon_rank_gold_ribbon.svg';
import RankPlatinumNoRibbonSVG from './icon_rank_platinum_no_ribbon.svg';
import RankPlatinumRibbonSVG from './icon_rank_platinum_ribbon.svg';
import RankRexFilledSVG from './icon_rank_rex_filled.svg';
import RankRexOutlineSVG from './icon_rank_rex_outline.svg';
import RankSilverNoRibbonSVG from './icon_rank_silver_no_ribbon.svg';
import RankSilverRibbonSVG from './icon_rank_silver_ribbon.svg';
import ReEnergyFilledSVG from './icon_re_energy_filled.svg';
import ReFoodFilledSVG from './icon_re_food_filled.svg';
import RePlantFilledSVG from './icon_re_plant_filled.svg';
import ReTraditionFilledSVG from './icon_re_tradition_filled.svg';
import ReWasteFilledSVG from './icon_re_waste_filled.svg';
import ReWaterFilledSVG from './icon_re_water_filled.svg';
import RebookFilledSVG from './icon_rebook_filled.svg';
import RefreshFilledSVG from './icon_refresh_filled.svg';
import ResortFilledSVG from './icon_resort_filled.svg';
import ReturnArrowFilledSVG from './icon_return_arrow_filled.svg';
import RobotChatFilledSVG from './icon_robot_chat_filled.svg';
import RoomBalconyFilledSVG from './icon_room_balcony_filled.svg';
import RoomBathAndToiletFilledSVG from './icon_room_bath_and_toilet_filled.svg';
import RoomBathtubFilledSVG from './icon_room_bathtub_filled.svg';
import RoomBridgeViewFilledSVG from './icon_room_bridge_view_filled.svg';
import RoomCherryBlossomViewFilledSVG from './icon_room_cherry_blossom_view_filled.svg';
import RoomCityViewFilledSVG from './icon_room_city_view_filled.svg';
import RoomCornerRoomFilledSVG from './icon_room_corner_room_filled.svg';
import RoomCourtyardViewFilledSVG from './icon_room_courtyard_view_filled.svg';
import RoomDesignatedSmokingAreFilledSVG from './icon_room_designated_smoking_are_filled.svg';
import RoomDoorFilledSVG from './icon_room_door_filled.svg';
import RoomFireplaceFilledSVG from './icon_room_fireplace_filled.svg';
import RoomFireworksViewFilledSVG from './icon_room_fireworks_view_filled.svg';
import RoomFlowerGardenViewFilledSVG from './icon_room_flower_garden_view_filled.svg';
import RoomFlowerGardenViewRiverViewFilledSVG from './icon_room_flower_garden_view_river_view_filled.svg';
import RoomForestViewFilledSVG from './icon_room_forest_view_filled.svg';
import RoomGardenViewFilledSVG from './icon_room_garden_view_filled.svg';
import RoomGolfCourseViewFilledSVG from './icon_room_golf_course_view_filled.svg';
import RoomHarborViewFilledSVG from './icon_room_harbor_view_filled.svg';
import RoomHillSideViewFilledSVG from './icon_room_hill_side_view_filled.svg';
import RoomJetBathFilledSVG from './icon_room_jet_bath_filled.svg';
import RoomKitchenFilledSVG from './icon_room_kitchen_filled.svg';
import RoomLakeViewFilledSVG from './icon_room_lake_view_filled.svg';
import RoomLivingRoomFilledSVG from './icon_room_living_room_filled.svg';
import RoomMapleViewFilledSVG from './icon_room_maple_view_filled.svg';
import RoomMountFujiViewFilledSVG from './icon_room_mount_fuji_view_filled.svg';
import RoomMountainViewFilledSVG from './icon_room_mountain_view_filled.svg';
import RoomNightlifeViewFilledSVG from './icon_room_nightlife_view_filled.svg';
import RoomNoSmokingFilledSVG from './icon_room_no_smoking_filled.svg';
import RoomOceanViewCoralSeaViewFilledSVG from './icon_room_ocean_view_coral_sea_view_filled.svg';
import RoomPalaceViewFilledSVG from './icon_room_palace_view_filled.svg';
import RoomPanoramicViewFilledSVG from './icon_room_panoramic_view_filled.svg';
import RoomParkViewFilledSVG from './icon_room_park_view_filled.svg';
import RoomPoolViewOutlineSVG from './icon_room_pool_view_outline.svg';
import RoomRenovatedRoomFilledSVG from './icon_room_renovated_room_filled.svg';
import RoomSeparateBathToiletFilledSVG from './icon_room_separate_bath_toilet_filled.svg';
import RoomSharedRoomFilledSVG from './icon_room_shared_room_filled.svg';
import RoomShowerOnlyFilledSVG from './icon_room_shower_only_filled.svg';
import RoomShowerToiletFilledSVG from './icon_room_shower_toilet_filled.svg';
import RoomSizeFilledSVG from './icon_room_size_filled.svg';
import RoomSmokingFilledSVG from './icon_room_smoking_filled.svg';
import RoomSmokingOrNoFilledSVG from './icon_room_smoking_or_no_filled.svg';
import RoomTatamiFilledSVG from './icon_room_tatami_filled.svg';
import RoomToiletBathroomFilledSVG from './icon_room_toilet_bathroom_filled.svg';
import RoomTokyoTowerViewFilledSVG from './icon_room_tokyo_tower_view_filled.svg';
import RoomUpgradeFilledSVG from './icon_room_upgrade_filled.svg';
import RoomViewChosenByHotelFilledSVG from './icon_room_view_chosen_by_hotel_filled.svg';
import RoomWindowFilledSVG from './icon_room_window_filled.svg';
import Rotate2FilledSVG from './icon_rotate_2_filled.svg';
import RotateFilledSVG from './icon_rotate__filled.svg';
import SakuraFilledSVG from './icon_sakura_filled.svg';
import SaveRexFilledSVG from './icon_save_rex_filled.svg';
import SaveRexOutlineSVG from './icon_save_rex_outline.svg';
import SearchFilledSVG from './icon_search_filled.svg';
import SearchHistoryRexFilledSVG from './icon_search_history_rex_filled.svg';
import SearchHistoryRexOutlineSVG from './icon_search_history_rex_outline.svg';
import SendRaiFilledSVG from './icon_send_rai_filled.svg';
import SendRaiOutlineSVG from './icon_send_rai_outline.svg';
import SendRexFilledSVG from './icon_send_rex_filled.svg';
import SendRexOutlineSVG from './icon_send_rex_outline.svg';
import SettingsRexFilledSVG from './icon_settings_rex_filled.svg';
import SettingsRexOutlineSVG from './icon_settings_rex_outline.svg';
import ShareFilledSVG from './icon_share_filled.svg';
import ShareRexFilledSVG from './icon_share_rex_filled.svg';
import ShareRexOutlineSVG from './icon_share_rex_outline.svg';
import ShineFilledSVG from './icon_shine_filled.svg';
import ShowRexFilledSVG from './icon_show_rex_filled.svg';
import ShowRexOutlineSVG from './icon_show_rex_outline.svg';
import SliderRexFilledSVG from './icon_slider_rex_filled.svg';
import SliderRexOutlineSVG from './icon_slider_rex_outline.svg';
import SnowmanFilledSVG from './icon_snowman_filled.svg';
import SnsFacebookGrayFilledSVG from './icon_sns_facebook_gray_filled.svg';
import SnsFacebookNewFilledSVG from './icon_sns_facebook_new_filled.svg';
import SnsFacebookOldFilledSVG from './icon_sns_facebook_old_filled.svg';
import SnsGooglemapFilledSVG from './icon_sns_googlemap_filled.svg';
import SnsInstagramNewFilledSVG from './icon_sns_instagram_new_filled.svg';
import SnsInstagramOutlineSVG from './icon_sns_instagram_outline.svg';
import SnsInstagramSolidSVG from './icon_sns_instagram_solid.svg';
import SnsLineFilledSVG from './icon_sns_line_filled.svg';
import SnsNoteFilledSVG from './icon_sns_note_filled.svg';
import SnsRakutenRoomFilledSVG from './icon_sns_rakuten_room_filled.svg';
import SnsTiktokFilledSVG from './icon_sns_tiktok_filled.svg';
import SnsViberFilledSVG from './icon_sns_viber_filled.svg';
import SnsWhatsAppFilledSVG from './icon_sns_whats_app_filled.svg';
import SnsXFrameFilledSVG from './icon_sns_x_frame_filled.svg';
import SnsXOutlineSVG from './icon_sns_x_outline.svg';
import SnsYoutubeFilledSVG from './icon_sns_youtube_filled.svg';
import SortArrowFilledSVG from './icon_sort_arrow_filled.svg';
import StarRexFilledSVG from './icon_star_rex_filled.svg';
import StarRexOutlineSVG from './icon_star_rex_outline.svg';
import StopFilledSVG from './icon_stop_filled.svg';
import SubtractIconSVG from './icon_subtract_icon.svg';
import SuccessColoredOutlinedSVG from './icon_success_colored_outlined.svg';
import SuccessFilledSVG from './icon_success_filled.svg';
import SuitcaseFilledSVG from './icon_suitcase_filled.svg';
import SuitcaseOutlineSVG from './icon_suitcase_outline.svg';
import SummerVacationFilledSVG from './icon_summer_vacation_filled.svg';
import SunFilledSVG from './icon_sun_filled.svg';
import SurveyRexFilledSVG from './icon_survey_rex_filled.svg';
import SurveyRexOutlineSVG from './icon_survey_rex_outline.svg';
import SustainabilityRexFilledSVG from './icon_sustainability_rex_filled.svg';
import SustainabilityRexOutlineSVG from './icon_sustainability_rex_outline.svg';
import TabletRexFilledSVG from './icon_tablet_rex_filled.svg';
import TabletRexOutlineSVG from './icon_tablet_rex_outline.svg';
import TargetFilledSVG from './icon_target_filled.svg';
import TargetRexFilledSVG from './icon_target_rex_filled.svg';
import TargetRexOutlineSVG from './icon_target_rex_outline.svg';
import Time24HourFilledSVG from './icon_time_24_hour_filled.svg';
import TimeCheckInFilledSVG from './icon_time_check_in_filled.svg';
import TimeCheckOutFilledSVG from './icon_time_check_out_filled.svg';
import TimeClockFilledSVG from './icon_time_clock_filled.svg';
import TimeClockOutlineSVG from './icon_time_clock_outline.svg';
import TimeTimerFilledSVG from './icon_time_timer_filled.svg';
import TimeWaitFilledSVG from './icon_time_wait_filled.svg';
import TransportationAirplane2FilledSVG from './icon_transportation_airplane_2_filled.svg';
import TransportationAirplaneOutlineSVG from './icon_transportation_airplane_outline.svg';
import TransportationAirportShuttleBusFilledSVG from './icon_transportation_airport_shuttle_bus_filled.svg';
import TransportationBusFilledSVG from './icon_transportation_bus_filled.svg';
import TransportationBusRexFilledSVG from './icon_transportation_bus_rex_filled.svg';
import TransportationBusRexOutlineSVG from './icon_transportation_bus_rex_outline.svg';
import TransportationBusStopFilledSVG from './icon_transportation_bus_stop_filled.svg';
import TransportationCarFrontRexFilledSVG from './icon_transportation_car_front_rex_filled.svg';
import TransportationCarFrontRexOutlineSVG from './icon_transportation_car_front_rex_outline.svg';
import TransportationCarSideFilledSVG from './icon_transportation_car_side_filled.svg';
import TransportationDropoffFilledSVG from './icon_transportation_dropoff_filled.svg';
import TransportationFerryBoatFilledSVG from './icon_transportation_ferry_boat_filled.svg';
import TransportationFerryRexFilledSVG from './icon_transportation_ferry_rex_filled.svg';
import TransportationFerryRexOutlineSVG from './icon_transportation_ferry_rex_outline.svg';
import TransportationShuttleBusFilledSVG from './icon_transportation_shuttle_bus_filled.svg';
import TransportationTrainFilledSVG from './icon_transportation_train_filled.svg';
import TransportationTruckRexFilledSVG from './icon_transportation_truck_rex_filled.svg';
import TransportationTruckRexOutlineSVG from './icon_transportation_truck_rex_outline.svg';
import TransportationWalkingFilledSVG from './icon_transportation_walking_filled.svg';
import TravelInsuranceFilledSVG from './icon_travel_insurance_filled.svg';
import UploadRexFilledSVG from './icon_upload_rex_filled.svg';
import UploadRexOutlineSVG from './icon_upload_rex_outline.svg';
import UserReviewFilledSVG from './icon_user_review_filled.svg';
import VerticalDotsFilledSVG from './icon_vertical_dots_filled.svg';
import VideoFilledSVG from './icon_video_filled.svg';
import VoiceInputRexFilledSVG from './icon_voice_input_rex_filled.svg';
import VoiceInputRexOutlineSVG from './icon_voice_input_rex_outline.svg';
import VolumeFilledSVG from './icon_volume_filled.svg';
import VolumeSilentFilledSVG from './icon_volume_silent_filled.svg';
import WarningGreyFilledSVG from './icon_warning.svg';
import WaterDropFilledSVG from './icon_water_drop_filled.svg';
import WinterVacationFilledSVG from './icon_winter_vacation_filled.svg';
import WorldRexFilledSVG from './icon_world_rex_filled.svg';
import WorldRexOutlineSVG from './icon_world_rex_outline.svg';
import YenCoinOutlineSVG from './icon_yen_coin_outline.svg';
import YenEnFilledSVG from './icon_yen_en_filled.svg';
import YenJpFilledSVG from './icon_yen_jp_filled.svg';
import ZipRexFilledSVG from './icon_zip_rex_filled.svg';
import ZipRexOutlineSVG from './icon_zip_rex_outline.svg';
import ZoomInRexFilledSVG from './icon_zoom_in_rex_filled.svg';
import ZoomInRexOutlineSVG from './icon_zoom_in_rex_outline.svg';
import ZoomOutRexFilledSVG from './icon_zoom_out_rex_filled.svg';
import ZoomOutRexOutlineSVG from './icon_zoom_out_rex_outline.svg';

export const AttentionIcon = withIconProps(AttentionSVG);
export const CheckmarkIcon = withIconProps(CheckmarkSVG);
export const ErrorFilledIcon = withIconProps(ErrorFilledSVG);
export const ErrorColoredOutlinedIcon = withIconProps(ErrorColoredOutlinedSVG);

export const ErrorOutlineIcon = withIconProps(ErrorOutlineSVG);
export const ActivityBoatFilledIcon = withIconProps(ActivityBoatFilledSVG);
export const ActivityDivingFilledIcon = withIconProps(ActivityDivingFilledSVG);
export const ActivityFishingFilledIcon = withIconProps(ActivityFishingFilledSVG);
export const ActivityGolfFilledIcon = withIconProps(ActivityGolfFilledSVG);
export const ActivityMassageFilledIcon = withIconProps(ActivityMassageFilledSVG);
export const ActivityParachuteFilledIcon = withIconProps(ActivityParachuteFilledSVG);
export const ActivityPotteryFilledIcon = withIconProps(ActivityPotteryFilledSVG);
export const ActivityRowingFilledIcon = withIconProps(ActivityRowingFilledSVG);
export const ActivitySkiFilledIcon = withIconProps(ActivitySkiFilledSVG);
export const ActivitySnowboardFilledIcon = withIconProps(ActivitySnowboardFilledSVG);
export const ActivitySurfingFilledIcon = withIconProps(ActivitySurfingFilledSVG);
export const ActivityTrekkingFilledIcon = withIconProps(ActivityTrekkingFilledSVG);
export const AddMediaFilledIcon = withIconProps(AddMediaFilledSVG);
export const AddMediaOutlineIcon = withIconProps(AddMediaOutlineSVG);
export const AddOnFilledIcon = withIconProps(AddOnFilledSVG);
export const AiSuggestionShineFilledIcon = withIconProps(AiSuggestionShineFilledSVG);
export const AlertRexFilledIcon = withIconProps(AlertRexFilledSVG);
export const AlertColoredOutlinedIcon = withIconProps(AlertColoredOutlinedSVG);
export const AmenitiesAdapterFilledIcon = withIconProps(AmenitiesAdapterFilledSVG);
export const AmenitiesAirConditionerFilledIcon = withIconProps(AmenitiesAirConditionerFilledSVG);
export const AmenitiesAirPurifierFilledIcon = withIconProps(AmenitiesAirPurifierFilledSVG);
export const AmenitiesBathTowelFilledIcon = withIconProps(AmenitiesBathTowelFilledSVG);
export const AmenitiesBottleWaterFilledIcon = withIconProps(AmenitiesBottleWaterFilledSVG);
export const AmenitiesClosetFilledIcon = withIconProps(AmenitiesClosetFilledSVG);
export const AmenitiesDeskFilledIcon = withIconProps(AmenitiesDeskFilledSVG);
export const AmenitiesDressCodeFilledIcon = withIconProps(AmenitiesDressCodeFilledSVG);
export const AmenitiesDryCleaningFilledIcon = withIconProps(AmenitiesDryCleaningFilledSVG);
export const AmenitiesDvdFilledIcon = withIconProps(AmenitiesDvdFilledSVG);
export const AmenitiesFanFilledIcon = withIconProps(AmenitiesFanFilledSVG);
export const AmenitiesHairDryerFilledIcon = withIconProps(AmenitiesHairDryerFilledSVG);
export const AmenitiesIronFilledIcon = withIconProps(AmenitiesIronFilledSVG);
export const AmenitiesLightbulbFilledIcon = withIconProps(AmenitiesLightbulbFilledSVG);
export const AmenitiesLockerFilledIcon = withIconProps(AmenitiesLockerFilledSVG);
export const AmenitiesLuggageFilledIcon = withIconProps(AmenitiesLuggageFilledSVG);
export const AmenitiesMicrowaveFilledIcon = withIconProps(AmenitiesMicrowaveFilledSVG);
export const AmenitiesPocketWifiFilledIcon = withIconProps(AmenitiesPocketWifiFilledSVG);
export const AmenitiesPowerOutletFilledIcon = withIconProps(AmenitiesPowerOutletFilledSVG);
export const AmenitiesRefrigeratorFilledIcon = withIconProps(AmenitiesRefrigeratorFilledSVG);
export const AmenitiesRoomWifiFilledIcon = withIconProps(AmenitiesRoomWifiFilledSVG);
export const AmenitiesSafeFilledIcon = withIconProps(AmenitiesSafeFilledSVG);
export const AmenitiesSoapAndShampooFilledIcon = withIconProps(AmenitiesSoapAndShampooFilledSVG);
export const AmenitiesSprayFilledIcon = withIconProps(AmenitiesSprayFilledSVG);
export const AmenitiesTelevisionTvFilledIcon = withIconProps(AmenitiesTelevisionTvFilledSVG);
export const AmenitiesTrouserPresserFilledIcon = withIconProps(AmenitiesTrouserPresserFilledSVG);
export const AmenitiesWashingMachineFilledIcon = withIconProps(AmenitiesWashingMachineFilledSVG);
export const AmenitiesWasteFilledIcon = withIconProps(AmenitiesWasteFilledSVG);
export const AmenitiesWifiFilledIcon = withIconProps(AmenitiesWifiFilledSVG);
export const AmenitiesWiredInternetFilledIcon = withIconProps(AmenitiesWiredInternetFilledSVG);
export const AmenitiesYukataFilledIcon = withIconProps(AmenitiesYukataFilledSVG);
export const ArchiveDeleteInboundIsUsingFilledIcon = withIconProps(
  ArchiveDeleteInboundIsUsingFilledSVG,
);
export const AreaSearchFilledIcon = withIconProps(AreaSearchFilledSVG);
export const ArrowCircleChevronDownFilledIcon = withIconProps(ArrowCircleChevronDownFilledSVG);
export const ArrowCircleChevronLeftFilledIcon = withIconProps(ArrowCircleChevronLeftFilledSVG);
export const ArrowCircleChevronRightFilledIcon = withIconProps(ArrowCircleChevronRightFilledSVG);
export const ArrowCircleChevronUpFilledIcon = withIconProps(ArrowCircleChevronUpFilledSVG);
export const ArrowCircleDownFilledIcon = withIconProps(ArrowCircleDownFilledSVG);
export const ArrowCircleDownOutlineIcon = withIconProps(ArrowCircleDownOutlineSVG);
export const ArrowCircleLeftFilledIcon = withIconProps(ArrowCircleLeftFilledSVG);
export const ArrowCircleLeftOutlineIcon = withIconProps(ArrowCircleLeftOutlineSVG);
export const ArrowCircleRightFilledIcon = withIconProps(ArrowCircleRightFilledSVG);
export const ArrowCircleRightOutlineIcon = withIconProps(ArrowCircleRightOutlineSVG);
export const ArrowCircleUpFilledIcon = withIconProps(ArrowCircleUpFilledSVG);
export const ArrowCircleUpOutlineIcon = withIconProps(ArrowCircleUpOutlineSVG);
export const ArrowLongDownFilledIcon = withIconProps(ArrowLongDownFilledSVG);
export const ArrowLongLeftFilledIcon = withIconProps(ArrowLongLeftFilledSVG);
export const ArrowLongRightFilledIcon = withIconProps(ArrowLongRightFilledSVG);
export const ArrowLongUpFilledIcon = withIconProps(ArrowLongUpFilledSVG);
export const ArrowShapeDownFilledIcon = withIconProps(ArrowShapeDownFilledSVG);
export const ArrowShapeLeftFilledIcon = withIconProps(ArrowShapeLeftFilledSVG);
export const ArrowShapeRightFilledIcon = withIconProps(ArrowShapeRightFilledSVG);
export const ArrowShapeUpFilledIcon = withIconProps(ArrowShapeUpFilledSVG);
export const AspectRatioOutlineIcon = withIconProps(AspectRatioOutlineSVG);
export const AwardFilledIcon = withIconProps(AwardFilledSVG);
export const BackwardFilledIcon = withIconProps(BackwardFilledSVG);
export const BanRexFilledIcon = withIconProps(BanRexFilledSVG);
export const BanRexOutlineIcon = withIconProps(BanRexOutlineSVG);
export const BarcodeRexFilledIcon = withIconProps(BarcodeRexFilledSVG);
export const BarcodeRexOutlineIcon = withIconProps(BarcodeRexOutlineSVG);
export const BeachFilledIcon = withIconProps(BeachFilledSVG);
export const BedBabyCribFilledIcon = withIconProps(BedBabyCribFilledSVG);
export const BedBunkBedFilledIcon = withIconProps(BedBunkBedFilledSVG);
export const BedDoubleBedFilledIcon = withIconProps(BedDoubleBedFilledSVG);
export const BedExtraBedFilledIcon = withIconProps(BedExtraBedFilledSVG);
export const BedFutonFilledIcon = withIconProps(BedFutonFilledSVG);
export const BedLoftBedFilledIcon = withIconProps(BedLoftBedFilledSVG);
export const BedNoBedFilledIcon = withIconProps(BedNoBedFilledSVG);
export const BedRoomSingleBedFilledIcon = withIconProps(BedRoomSingleBedFilledSVG);
export const BedShareBedFilledIcon = withIconProps(BedShareBedFilledSVG);
export const BedSofaBedFilledIcon = withIconProps(BedSofaBedFilledSVG);
export const BedSuiteSpecialLuxuryFilledIcon = withIconProps(BedSuiteSpecialLuxuryFilledSVG);
export const BedTripleBedFilledIcon = withIconProps(BedTripleBedFilledSVG);
export const BedTwinBedFilledIcon = withIconProps(BedTwinBedFilledSVG);
export const BowFilledIcon = withIconProps(BowFilledSVG);
export const BrowsingHistoryRexFilledIcon = withIconProps(BrowsingHistoryRexFilledSVG);
export const BrowsingHistoryRexOutlineIcon = withIconProps(BrowsingHistoryRexOutlineSVG);
export const BuildingRexFilledIcon = withIconProps(BuildingRexFilledSVG);
export const BuildingRexOutlineIcon = withIconProps(BuildingRexOutlineSVG);
export const BusinessHotelFilledIcon = withIconProps(BusinessHotelFilledSVG);
export const CalculatorRexFilledIcon = withIconProps(CalculatorRexFilledSVG);
export const CalculatorRexOutlineIcon = withIconProps(CalculatorRexOutlineSVG);
export const CalendarAddCalendarFilledIcon = withIconProps(CalendarAddCalendarFilledSVG);
export const CalendarAnniversaryFilledIcon = withIconProps(CalendarAnniversaryFilledSVG);
export const CalendarCancelFilledIcon = withIconProps(CalendarCancelFilledSVG);
export const CalendarChangeFilledIcon = withIconProps(CalendarChangeFilledSVG);
export const CalendarFailFilledIcon = withIconProps(CalendarFailFilledSVG);
export const CalendarRexFilledIcon = withIconProps(CalendarRexFilledSVG);
export const CalendarRexOutlineIcon = withIconProps(CalendarRexOutlineSVG);
export const CalendarSpecialFilledIcon = withIconProps(CalendarSpecialFilledSVG);
export const CalendarSucceedFilledIcon = withIconProps(CalendarSucceedFilledSVG);
export const CalendarVacancyFilledIcon = withIconProps(CalendarVacancyFilledSVG);
export const CameraRexFilledIcon = withIconProps(CameraRexFilledSVG);
export const CameraRexOutlineIcon = withIconProps(CameraRexOutlineSVG);
export const CheckCircleFilledIcon = withIconProps(CheckCircleFilledSVG);
export const CheckCircleOutlineIcon = withIconProps(CheckCircleOutlineSVG);
export const CheckFilledIcon = withIconProps(CheckFilledSVG);
export const ChevronBoldDownFilledIcon = withIconProps(ChevronBoldDownFilledSVG);
export const ChevronBoldLeftFilledIcon = withIconProps(ChevronBoldLeftFilledSVG);
export const ChevronBoldRightFilledIcon = withIconProps(ChevronBoldRightFilledSVG);
export const ChevronBoldUpFilledIcon = withIconProps(ChevronBoldUpFilledSVG);
export const ChevronRegularDownFilledIcon = withIconProps(ChevronRegularDownFilledSVG);
export const ChevronRegularLeftFilledIcon = withIconProps(ChevronRegularLeftFilledSVG);
export const ChevronRegularRightFilledIcon = withIconProps(ChevronRegularRightFilledSVG);
export const ChevronRegularUpFilledIcon = withIconProps(ChevronRegularUpFilledSVG);
export const CloseIcon = withIconProps(CloseSVG);
export const ClearFilledIcon = withIconProps(ClearFilledSVG);
export const CloseFilledIcon = withIconProps(CloseFilledSVG);
export const CloseOutlineIcon = withIconProps(CloseOutlineSVG);
export const CloudRexFilledIcon = withIconProps(CloudRexFilledSVG);
export const CloudRexOutlineIcon = withIconProps(CloudRexOutlineSVG);
export const CommentRexFilledIcon = withIconProps(CommentRexFilledSVG);
export const CommentRexOutlineIcon = withIconProps(CommentRexOutlineSVG);
export const CompareRexFilledIcon = withIconProps(CompareRexFilledSVG);
export const CompareRexOutlineIcon = withIconProps(CompareRexOutlineSVG);
export const CopyFilledIcon = withIconProps(CopyFilledSVG);
export const CopyrightOutlineIcon = withIconProps(CopyrightOutlineSVG);
export const CreditCardAmericanExpressIcon = withIconProps(CreditCardAmericanExpressSVG);
export const CreditCardAmericanExpressBackCvvIcon = withIconProps(
  CreditCardAmericanExpressBackCvvSVG,
);
export const CreditCardBackCvvIcon = withIconProps(CreditCardBackCvvSVG);
export const CreditCardCashIcon = withIconProps(CreditCardCashSVG);
export const CreditCardChinaUnionpayIcon = withIconProps(CreditCardChinaUnionpaySVG);
export const CreditCardDinersIcon = withIconProps(CreditCardDinersSVG);
export const CreditCardDiscoverIcon = withIconProps(CreditCardDiscoverSVG);
export const CreditCardJcbIcon = withIconProps(CreditCardJcbSVG);
export const CreditCardMasterCardIcon = withIconProps(CreditCardMasterCardSVG);
export const CreditCardOtherCreditCardNameIcon = withIconProps(CreditCardOtherCreditCardNameSVG);
export const CreditCardPlaceholderIcon = withIconProps(CreditCardPlaceholderSVG);
export const CreditCardVisaIcon = withIconProps(CreditCardVisaSVG);
export const CropAndRotateFilledIcon = withIconProps(CropAndRotateFilledSVG);
export const CropFilledIcon = withIconProps(CropFilledSVG);
export const CrownFilledIcon = withIconProps(CrownFilledSVG);
export const CurrentLocationFilledIcon = withIconProps(CurrentLocationFilledSVG);
export const CurrentLocationOutlineIcon = withIconProps(CurrentLocationOutlineSVG);
export const DeleteRexFilledIcon = withIconProps(DeleteRexFilledSVG);
export const DeleteRexOutlineIcon = withIconProps(DeleteRexOutlineSVG);
export const DesktopRexFilledIcon = withIconProps(DesktopRexFilledSVG);
export const DesktopRexOutlineIcon = withIconProps(DesktopRexOutlineSVG);
export const DiscussionRexFilledIcon = withIconProps(DiscussionRexFilledSVG);
export const DiscussionRexOutlineIcon = withIconProps(DiscussionRexOutlineSVG);
export const DiversityFilledIcon = withIconProps(DiversityFilledSVG);
export const DocumentFormRexFilledIcon = withIconProps(DocumentFormRexFilledSVG);
export const DocumentFormRexOutlineIcon = withIconProps(DocumentFormRexOutlineSVG);
export const DomesticMapRexFilledIcon = withIconProps(DomesticMapRexFilledSVG);
export const DomesticMapRexOutlineIcon = withIconProps(DomesticMapRexOutlineSVG);
export const DotFilledIcon = withIconProps(DotFilledSVG);
export const DownloadRexFilledIcon = withIconProps(DownloadRexFilledSVG);
export const DownloadRexOutlineIcon = withIconProps(DownloadRexOutlineSVG);
export const DynamicPackageFilledIcon = withIconProps(DynamicPackageFilledSVG);
export const EditRexFilledIcon = withIconProps(EditRexFilledSVG);
export const EditRexOutlineIcon = withIconProps(EditRexOutlineSVG);
export const EmergencyFilledIcon = withIconProps(EmergencyFilledSVG);
export const EmotionHappyFilledIcon = withIconProps(EmotionHappyFilledSVG);
export const EmotionLoveFilledIcon = withIconProps(EmotionLoveFilledSVG);
export const EmotionNeutralFilledIcon = withIconProps(EmotionNeutralFilledSVG);
export const EmotionSadFilledIcon = withIconProps(EmotionSadFilledSVG);
export const EmotionSickFilledIcon = withIconProps(EmotionSickFilledSVG);
export const EmotionSurpriseFilledIcon = withIconProps(EmotionSurpriseFilledSVG);
export const EmotionUnhappyFilledIcon = withIconProps(EmotionUnhappyFilledSVG);
export const EventBowFilledIcon = withIconProps(EventBowFilledSVG);
export const EventCelebrationFilledIcon = withIconProps(EventCelebrationFilledSVG);
export const EventPartyFilledIcon = withIconProps(EventPartyFilledSVG);
export const ExpandFilledIcon = withIconProps(ExpandFilledSVG);
export const EyeFilledIcon = withIconProps(EyeFilledSVG);
export const FacilityAccessibilityFilledIcon = withIconProps(FacilityAccessibilityFilledSVG);
export const FacilityAllinclusiveFilledIcon = withIconProps(FacilityAllinclusiveFilledSVG);
export const FacilityBabysitterFilledIcon = withIconProps(FacilityBabysitterFilledSVG);
export const FacilityClubLoungeFilledIcon = withIconProps(FacilityClubLoungeFilledSVG);
export const FacilityCommunalBathFilledIcon = withIconProps(FacilityCommunalBathFilledSVG);
export const FacilityElevatorFilledIcon = withIconProps(FacilityElevatorFilledSVG);
export const FacilityGrandBathFilledIcon = withIconProps(FacilityGrandBathFilledSVG);
export const FacilityGymFilledIcon = withIconProps(FacilityGymFilledSVG);
export const FacilityHotSpringFilledIcon = withIconProps(FacilityHotSpringFilledSVG);
export const FacilityIndoorHotSpringFilledIcon = withIconProps(FacilityIndoorHotSpringFilledSVG);
export const FacilityJapaneseGardenFilledIcon = withIconProps(FacilityJapaneseGardenFilledSVG);
export const FacilityNoParkingFilledIcon = withIconProps(FacilityNoParkingFilledSVG);
export const FacilityNursingRoomFilledIcon = withIconProps(FacilityNursingRoomFilledSVG);
export const FacilityOpenairBathFilledIcon = withIconProps(FacilityOpenairBathFilledSVG);
export const FacilityParkingFilledIcon = withIconProps(FacilityParkingFilledSVG);
export const FacilityPetsFilledIcon = withIconProps(FacilityPetsFilledSVG);
export const FacilityPoolFilledIcon = withIconProps(FacilityPoolFilledSVG);
export const FacilityPrivateBathFilledIcon = withIconProps(FacilityPrivateBathFilledSVG);
export const FacilitySemiOpenairBathFilledIcon = withIconProps(FacilitySemiOpenairBathFilledSVG);
export const FacilitySkyLoungeFilledIcon = withIconProps(FacilitySkyLoungeFilledSVG);
export const FacilityStairsFilledIcon = withIconProps(FacilityStairsFilledSVG);
export const FilterRexFilledIcon = withIconProps(FilterRexFilledSVG);
export const FilterRexOutlineIcon = withIconProps(FilterRexOutlineSVG);
export const FireworksFilledIcon = withIconProps(FireworksFilledSVG);
export const FlagFilledIcon = withIconProps(FlagFilledSVG);
export const FlagOutlineIcon = withIconProps(FlagOutlineSVG);
export const FolderRexFilledIcon = withIconProps(FolderRexFilledSVG);
export const FolderRexOutlineIcon = withIconProps(FolderRexOutlineSVG);
export const FoodBarFilledIcon = withIconProps(FoodBarFilledSVG);
export const FoodBbqFilledIcon = withIconProps(FoodBbqFilledSVG);
export const FoodBentoFilledIcon = withIconProps(FoodBentoFilledSVG);
export const FoodBreakfastFilledIcon = withIconProps(FoodBreakfastFilledSVG);
export const FoodBreakfastVoucherFilledIcon = withIconProps(FoodBreakfastVoucherFilledSVG);
export const FoodCafeFilledIcon = withIconProps(FoodCafeFilledSVG);
export const FoodDinnerFilledIcon = withIconProps(FoodDinnerFilledSVG);
export const FoodFineDiningFilledIcon = withIconProps(FoodFineDiningFilledSVG);
export const FoodHalalFilledIcon = withIconProps(FoodHalalFilledSVG);
export const FoodInRoomBreakfastFilledIcon = withIconProps(FoodInRoomBreakfastFilledSVG);
export const FoodLocalCuisineFilledIcon = withIconProps(FoodLocalCuisineFilledSVG);
export const FoodMealConsiderationFilledIcon = withIconProps(FoodMealConsiderationFilledSVG);
export const FoodMealFilledIcon = withIconProps(FoodMealFilledSVG);
export const FoodNoMealFilledIcon = withIconProps(FoodNoMealFilledSVG);
export const FoodPicnicFilledIcon = withIconProps(FoodPicnicFilledSVG);
export const FoodRoomServiceFilledIcon = withIconProps(FoodRoomServiceFilledSVG);
export const FoodUpgradeMealFilledIcon = withIconProps(FoodUpgradeMealFilledSVG);
export const FoodVegetarianFilledIcon = withIconProps(FoodVegetarianFilledSVG);
export const ForwardFilledIcon = withIconProps(ForwardFilledSVG);
export const GetCouponFilledIcon = withIconProps(GetCouponFilledSVG);
export const GoldenWeekFilledIcon = withIconProps(GoldenWeekFilledSVG);
export const GrabFilledIcon = withIconProps(GrabFilledSVG);
export const GuidebookOutlineIcon = withIconProps(GuidebookOutlineSVG);
export const HandleFilledIcon = withIconProps(HandleFilledSVG);
export const HelpRexFilledIcon = withIconProps(HelpRexFilledSVG);
export const HelpRexOutlineIcon = withIconProps(HelpRexOutlineSVG);
export const HideRexFilledIcon = withIconProps(HideRexFilledSVG);
export const HideRexOutlineIcon = withIconProps(HideRexOutlineSVG);
export const HomeRexFilledIcon = withIconProps(HomeRexFilledSVG);
export const HomeRexOutlineIcon = withIconProps(HomeRexOutlineSVG);
export const HorizontalDotsFilledIcon = withIconProps(HorizontalDotsFilledSVG);
export const HotelAnnexFilledIcon = withIconProps(HotelAnnexFilledSVG);
export const HotelCityFilledIcon = withIconProps(HotelCityFilledSVG);
export const HotelGlampingFilledIcon = withIconProps(HotelGlampingFilledSVG);
export const HotelHotelFilledIcon = withIconProps(HotelHotelFilledSVG);
export const HotelPackageFilledIcon = withIconProps(HotelPackageFilledSVG);
export const HotelRyokanFilledIcon = withIconProps(HotelRyokanFilledSVG);
export const IdentificationDocumentRexFilledIcon = withIconProps(
  IdentificationDocumentRexFilledSVG,
);
export const IdentificationDocumentRexOutlineIcon = withIconProps(
  IdentificationDocumentRexOutlineSVG,
);
export const ImageRexFilledIcon = withIconProps(ImageRexFilledSVG);
export const ImageRexOutlineIcon = withIconProps(ImageRexOutlineSVG);
export const ImageBrokenFilledIcon = withIconProps(ImageBrokenFilledSVG);
export const GalleryFilledIcon = withIconProps(GalleryFilledSVG);
export const InfoRexFilledIcon = withIconProps(InfoRexFilledSVG);
export const InfoRexOutlineIcon = withIconProps(InfoRexOutlineSVG);
export const InfoColoredOutlinedIcon = withIconProps(InfoColoredOutlinedSvg);
export const JapanQualityFilledIcon = withIconProps(JapanQualityFilledSVG);
export const KeyboardRexFilledIcon = withIconProps(KeyboardRexFilledSVG);
export const KeyboardRexOutlineIcon = withIconProps(KeyboardRexOutlineSVG);
export const LanguageRexFilledIcon = withIconProps(LanguageRexFilledSVG);
export const LanguageRexOutlineIcon = withIconProps(LanguageRexOutlineSVG);
export const LeafFilledIcon = withIconProps(LeafFilledSVG);
export const LegolandOutlineIcon = withIconProps(LegolandOutlineSVG);
export const LightModeFilledIcon = withIconProps(LightModeFilledSVG);
export const LikeRexFilledIcon = withIconProps(LikeRexFilledSVG);
export const LikeRexOutlineIcon = withIconProps(LikeRexOutlineSVG);
export const ListRexFilledIcon = withIconProps(ListRexFilledSVG);
export const ListRexOutlineIcon = withIconProps(ListRexOutlineSVG);
export const LoadingFilledIcon = withIconProps(LoadingFilledSVG);
export const LocalContributionFilledIcon = withIconProps(LocalContributionFilledSVG);
export const LocationRexFilledIcon = withIconProps(LocationRexFilledSVG);
export const LocationRexOutlineIcon = withIconProps(LocationRexOutlineSVG);
export const LoginFilledIcon = withIconProps(LoginFilledSVG);
export const LogoutFilledIcon = withIconProps(LogoutFilledSVG);
export const MagicWandFilledIcon = withIconProps(MagicWandFilledSVG);
export const MailRexFilledIcon = withIconProps(MailRexFilledSVG);
export const MailRexOutlineIcon = withIconProps(MailRexOutlineSVG);
export const MapRexFilledIcon = withIconProps(MapRexFilledSVG);
export const MapRexOutlineIcon = withIconProps(MapRexOutlineSVG);
export const MapleLeafFilledIcon = withIconProps(MapleLeafFilledSVG);
export const MediaRexFilledIcon = withIconProps(MediaRexFilledSVG);
export const MediaRexOutlineIcon = withIconProps(MediaRexOutlineSVG);
export const MenuAccountFilledIcon = withIconProps(MenuAccountFilledSVG);
export const MenuAccountOutlineIcon = withIconProps(MenuAccountOutlineSVG);
export const MenuCampaign2FilledIcon = withIconProps(MenuCampaign2FilledSVG);
export const MenuCampaign2OutlineIcon = withIconProps(MenuCampaign2OutlineSVG);
export const MenuCampaignFilledIcon = withIconProps(MenuCampaignFilledSVG);
export const MenuCampaignOutlineIcon = withIconProps(MenuCampaignOutlineSVG);
export const MenuFavoriteFilledIcon = withIconProps(MenuFavoriteFilledSVG);
export const MenuFavoriteOutlineIcon = withIconProps(MenuFavoriteOutlineSVG);
export const MenuHomeFilledIcon = withIconProps(MenuHomeFilledSVG);
export const MenuHomeOutlineIcon = withIconProps(MenuHomeOutlineSVG);
export const MenuOutlineIcon = withIconProps(MenuOutlineSVG);
export const MenuReservationSuitcaseFilledIcon = withIconProps(MenuReservationSuitcaseFilledSVG);
export const MenuReservationSuitcaseOutlineIcon = withIconProps(MenuReservationSuitcaseOutlineSVG);
export const MenuStarFilledIcon = withIconProps(MenuStarFilledSVG);
export const MenuStarHalfFilledIcon = withIconProps(MenuStarHalfFilledSVG);
export const MenuStarOutlineIcon = withIconProps(MenuStarOutlineSVG);
export const MidnightFilledIcon = withIconProps(MidnightFilledSVG);
export const MinusBoldFilledIcon = withIconProps(MinusBoldFilledSVG);
export const MinusInCircleFilledIcon = withIconProps(MinusInCircleFilledSVG);
export const MinusInCircleOutlineIcon = withIconProps(MinusInCircleOutlineSVG);
export const MinusInSquareFilledIcon = withIconProps(MinusInSquareFilledSVG);
export const MinusRegularFilledIcon = withIconProps(MinusRegularFilledSVG);
export const MobileRexFilledIcon = withIconProps(MobileRexFilledSVG);
export const MobileRexOutlineIcon = withIconProps(MobileRexOutlineSVG);
export const MusicFilledIcon = withIconProps(MusicFilledSVG);
export const NewPhoneFilledIcon = withIconProps(NewPhoneFilledSVG);
export const NewUserFilledIcon = withIconProps(NewUserFilledSVG);
export const NewWindowRexFilledIcon = withIconProps(NewWindowRexFilledSVG);
export const NewWindowRexOutlineIcon = withIconProps(NewWindowRexOutlineSVG);
export const NewsRexFilledIcon = withIconProps(NewsRexFilledSVG);
export const NewsRexOutlineIcon = withIconProps(NewsRexOutlineSVG);
export const NoticeRexFilledIcon = withIconProps(NoticeRexFilledSVG);
export const NoticeRexOutlineIcon = withIconProps(NoticeRexOutlineSVG);
export const NotificationRexFilledIcon = withIconProps(NotificationRexFilledSVG);
export const NotificationRexOutlineIcon = withIconProps(NotificationRexOutlineSVG);
export const OpenExternalFilledIcon = withIconProps(OpenExternalFilledSVG);
export const OtherInitiativesFilledIcon = withIconProps(OtherInitiativesFilledSVG);
export const PaintRexFilledIcon = withIconProps(PaintRexFilledSVG);
export const PaintRexOutlineIcon = withIconProps(PaintRexOutlineSVG);
export const PamphletFilledIcon = withIconProps(PamphletFilledSVG);
export const PauseFilledIcon = withIconProps(PauseFilledSVG);
export const PauseWithCircleFilledIcon = withIconProps(PauseWithCircleFilledSVG);
export const PaymentCashOnlyFilledIcon = withIconProps(PaymentCashOnlyFilledSVG);
export const PaymentCreditCardRexFilledIcon = withIconProps(PaymentCreditCardRexFilledSVG);
export const PaymentCreditCardRexOutlineIcon = withIconProps(PaymentCreditCardRexOutlineSVG);
export const PaymentCurrencyRexFilledIcon = withIconProps(PaymentCurrencyRexFilledSVG);
export const PaymentCurrencyRexOutlineIcon = withIconProps(PaymentCurrencyRexOutlineSVG);
export const PaymentElectricMoneyFilledIcon = withIconProps(PaymentElectricMoneyFilledSVG);
export const PaymentMethodCardMobileOutlineIcon = withIconProps(PaymentMethodCardMobileOutlineSVG);
export const PaymentMethodMobileFilledIcon = withIconProps(PaymentMethodMobileFilledSVG);
export const PaymentMethodMobileOutlineIcon = withIconProps(PaymentMethodMobileOutlineSVG);
export const PaymentNoCreditCardFilledIcon = withIconProps(PaymentNoCreditCardFilledSVG);
export const PaymentNonrefundFilledIcon = withIconProps(PaymentNonrefundFilledSVG);
export const PaymentPayOnSiteFilledIcon = withIconProps(PaymentPayOnSiteFilledSVG);
export const PaymentPaymentMethodFilledIcon = withIconProps(PaymentPaymentMethodFilledSVG);
export const PdfRexFilledIcon = withIconProps(PdfRexFilledSVG);
export const PdfRexOutlineIcon = withIconProps(PdfRexOutlineSVG);
export const PeopleAdultFilledIcon = withIconProps(PeopleAdultFilledSVG);
export const PeopleBabyFilledIcon = withIconProps(PeopleBabyFilledSVG);
export const PeopleChildFilledIcon = withIconProps(PeopleChildFilledSVG);
export const PeopleCloseAccountRexFilledIcon = withIconProps(PeopleCloseAccountRexFilledSVG);
export const PeopleCloseAccountRexOutlineIcon = withIconProps(PeopleCloseAccountRexOutlineSVG);
export const PeopleGroupOfPeopleFilledIcon = withIconProps(PeopleGroupOfPeopleFilledSVG);
export const PeopleManFilledIcon = withIconProps(PeopleManFilledSVG);
export const PeopleMemberFavoriteFilledIcon = withIconProps(PeopleMemberFavoriteFilledSVG);
export const PeopleMemberFavoriteOutlineIcon = withIconProps(PeopleMemberFavoriteOutlineSVG);
export const PeopleMyPageRexFilledIcon = withIconProps(PeopleMyPageRexFilledSVG);
export const PeopleMyPageRexOutlineIcon = withIconProps(PeopleMyPageRexOutlineSVG);
export const PeopleNobabyFilledIcon = withIconProps(PeopleNobabyFilledSVG);
export const PeopleReception2FilledIcon = withIconProps(PeopleReception2FilledSVG);
export const PeopleReception3FilledIcon = withIconProps(PeopleReception3FilledSVG);
export const PeopleReceptionFilledIcon = withIconProps(PeopleReceptionFilledSVG);
export const PeopleRegisterAccountRexFilledIcon = withIconProps(PeopleRegisterAccountRexFilledSVG);
export const PeopleRegisterAccountRexOutlineIcon = withIconProps(
  PeopleRegisterAccountRexOutlineSVG,
);
export const PeopleStaffFilledIcon = withIconProps(PeopleStaffFilledSVG);
export const PeopleUserRexFilledIcon = withIconProps(PeopleUserRexFilledSVG);
export const PeopleUserRexOutlineIcon = withIconProps(PeopleUserRexOutlineSVG);
export const PeopleWomanFilledIcon = withIconProps(PeopleWomanFilledSVG);
export const PhoneRexFilledIcon = withIconProps(PhoneRexFilledSVG);
export const PhoneRexOutlineIcon = withIconProps(PhoneRexOutlineSVG);
export const PinRexFilledIcon = withIconProps(PinRexFilledSVG);
export const PinRexOutlineIcon = withIconProps(PinRexOutlineSVG);
export const PlayFilledIcon = withIconProps(PlayFilledSVG);
export const PlayWithCircleFilledIcon = withIconProps(PlayWithCircleFilledSVG);
export const PlusBoldFilledIcon = withIconProps(PlusBoldFilledSVG);
export const PlusInCircleFilledIcon = withIconProps(PlusInCircleFilledSVG);
export const PlusInCircleOutlineIcon = withIconProps(PlusInCircleOutlineSVG);
export const PlusInSquareFilledIcon = withIconProps(PlusInSquareFilledSVG);
export const PlusRegularFilledIcon = withIconProps(PlusRegularFilledSVG);
export const PocAtmMachineFilledIcon = withIconProps(PocAtmMachineFilledSVG);
export const PocCampingFilledIcon = withIconProps(PocCampingFilledSVG);
export const PocChurchFilledIcon = withIconProps(PocChurchFilledSVG);
export const PocConvenienceStoreFilledIcon = withIconProps(PocConvenienceStoreFilledSVG);
export const PocFerrisWheelFilledIcon = withIconProps(PocFerrisWheelFilledSVG);
export const PocGolfFilledIcon = withIconProps(PocGolfFilledSVG);
export const PocKaraokeRoomFilledIcon = withIconProps(PocKaraokeRoomFilledSVG);
export const PocMuseumFilledIcon = withIconProps(PocMuseumFilledSVG);
export const PocPlaygroundFilledIcon = withIconProps(PocPlaygroundFilledSVG);
export const PocShopRexFilledIcon = withIconProps(PocShopRexFilledSVG);
export const PocShopRexOutlineIcon = withIconProps(PocShopRexOutlineSVG);
export const PocShoppingCartRexFilledIcon = withIconProps(PocShoppingCartRexFilledSVG);
export const PocShoppingCartRexOutlineIcon = withIconProps(PocShoppingCartRexOutlineSVG);
export const PocShoppingFilledIcon = withIconProps(PocShoppingFilledSVG);
export const PocSightseeing2FilledIcon = withIconProps(PocSightseeing2FilledSVG);
export const PocSightseeingFilledIcon = withIconProps(PocSightseeingFilledSVG);
export const PocSunsetFilledIcon = withIconProps(PocSunsetFilledSVG);
export const PocWindMillDutchFilledIcon = withIconProps(PocWindMillDutchFilledSVG);
export const PointBarcodeColorIcon = withIconProps(PointBarcodeColorSVG);
export const PointBarcodeOutlinedIcon = withIconProps(PointBarcodeOutlinedSVG);
export const PostalCodeFilledIcon = withIconProps(PostalCodeFilledSVG);
export const PrintRexFilledIcon = withIconProps(PrintRexFilledSVG);
export const PrintRexOutlineIcon = withIconProps(PrintRexOutlineSVG);
export const PromotionBestFilledIcon = withIconProps(PromotionBestFilledSVG);
export const PromotionBestOutlineIcon = withIconProps(PromotionBestOutlineSVG);
export const PromotionBonusProgramFilledIcon = withIconProps(PromotionBonusProgramFilledSVG);
export const PromotionBonusProgramOutlineIcon = withIconProps(PromotionBonusProgramOutlineSVG);
export const PromotionCampaignRexFilledIcon = withIconProps(PromotionCampaignRexFilledSVG);
export const PromotionCampaignRexOutlineIcon = withIconProps(PromotionCampaignRexOutlineSVG);
export const PromotionCouponFilledIcon = withIconProps(PromotionCouponFilledSVG);
export const PromotionCouponRexFilledIcon = withIconProps(PromotionCouponRexFilledSVG);
export const PromotionCouponRexOutlineIcon = withIconProps(PromotionCouponRexOutlineSVG);
export const PromotionEarlyBirdFilledIcon = withIconProps(PromotionEarlyBirdFilledSVG);
export const PromotionGiftFilledIcon = withIconProps(PromotionGiftFilledSVG);
export const PromotionMultipleCouponsFilledIcon = withIconProps(PromotionMultipleCouponsFilledSVG);
export const PromotionPointRewardRexFilledIcon = withIconProps(PromotionPointRewardRexFilledSVG);
export const PromotionPointRewardRexOutlineIcon = withIconProps(PromotionPointRewardRexOutlineSVG);
export const PromotionPointRexFilledIcon = withIconProps(PromotionPointRexFilledSVG);
export const PromotionPointRexOutlineIcon = withIconProps(PromotionPointRexOutlineSVG);
export const PromotionTagRexFilledIcon = withIconProps(PromotionTagRexFilledSVG);
export const PromotionTagRexOutlineIcon = withIconProps(PromotionTagRexOutlineSVG);
export const PromotionTicketRexFilledIcon = withIconProps(PromotionTicketRexFilledSVG);
export const PromotionTicketRexOutlineIcon = withIconProps(PromotionTicketRexOutlineSVG);
export const ProviderAirlinePlaceholderFilledIcon = withIconProps(
  ProviderAirlinePlaceholderFilledSVG,
);
export const PurchaseHistoryRexFilledIcon = withIconProps(PurchaseHistoryRexFilledSVG);
export const PurchaseHistoryRexOutlineIcon = withIconProps(PurchaseHistoryRexOutlineSVG);
export const QrCodeRexFilledIcon = withIconProps(QrCodeRexFilledSVG);
export const QrCodeRexOutlineIcon = withIconProps(QrCodeRexOutlineSVG);
export const RakutenAiFullFilledIcon = withIconProps(RakutenAiFullFilledSVG);
export const RakutenAiSymbolFilledIcon = withIconProps(RakutenAiSymbolFilledSVG);
export { default as RakutenAiIcon } from './RakutenAiIcon';
export { default as RakutenAiGrayIcon } from './RakutenAiIconGray';
export const RakutenFilledIcon = withIconProps(RakutenFilledSVG);
export const RakutenMobileOutlineIcon = withIconProps(RakutenMobileOutlineSVG);
export const Rank1CrownFilledIcon = withIconProps(Rank1CrownFilledSVG);
export const Rank2CrownFilledIcon = withIconProps(Rank2CrownFilledSVG);
export const Rank3CrownFilledIcon = withIconProps(Rank3CrownFilledSVG);
export const Rank4CrownFilledIcon = withIconProps(Rank4CrownFilledSVG);
export const Rank5CrownFilledIcon = withIconProps(Rank5CrownFilledSVG);
export const RankDiamondNoRibbonDarkModeIcon = withIconProps(RankDiamondNoRibbonDarkModeSVG);
export const RankDiamondNoRibbonLightModeIcon = withIconProps(RankDiamondNoRibbonLightModeSVG);
export const RankDiamondRibbonDarkModeIcon = withIconProps(RankDiamondRibbonDarkModeSVG);
export const RankDiamondRibbonLightModeIcon = withIconProps(RankDiamondRibbonLightModeSVG);
export const RankGoldNoRibbonIcon = withIconProps(RankGoldNoRibbonSVG);
export const RankGoldRibbonIcon = withIconProps(RankGoldRibbonSVG);
export const RankPlatinumNoRibbonIcon = withIconProps(RankPlatinumNoRibbonSVG);
export const RankPlatinumRibbonIcon = withIconProps(RankPlatinumRibbonSVG);
export const RankRexFilledIcon = withIconProps(RankRexFilledSVG);
export const RankRexOutlineIcon = withIconProps(RankRexOutlineSVG);
export const RankSilverNoRibbonIcon = withIconProps(RankSilverNoRibbonSVG);
export const RankSilverRibbonIcon = withIconProps(RankSilverRibbonSVG);
export const ReEnergyFilledIcon = withIconProps(ReEnergyFilledSVG);
export const ReFoodFilledIcon = withIconProps(ReFoodFilledSVG);
export const RePlantFilledIcon = withIconProps(RePlantFilledSVG);
export const ReTraditionFilledIcon = withIconProps(ReTraditionFilledSVG);
export const ReWasteFilledIcon = withIconProps(ReWasteFilledSVG);
export const ReWaterFilledIcon = withIconProps(ReWaterFilledSVG);
export const RebookFilledIcon = withIconProps(RebookFilledSVG);
export const RefreshFilledIcon = withIconProps(RefreshFilledSVG);
export const ResortFilledIcon = withIconProps(ResortFilledSVG);
export const ReturnArrowFilledIcon = withIconProps(ReturnArrowFilledSVG);
export const RobotChatFilledIcon = withIconProps(RobotChatFilledSVG);
export const RoomBalconyFilledIcon = withIconProps(RoomBalconyFilledSVG);
export const RoomBathAndToiletFilledIcon = withIconProps(RoomBathAndToiletFilledSVG);
export const RoomBathtubFilledIcon = withIconProps(RoomBathtubFilledSVG);
export const RoomBridgeViewFilledIcon = withIconProps(RoomBridgeViewFilledSVG);
export const RoomCherryBlossomViewFilledIcon = withIconProps(RoomCherryBlossomViewFilledSVG);
export const RoomCityViewFilledIcon = withIconProps(RoomCityViewFilledSVG);
export const RoomCornerRoomFilledIcon = withIconProps(RoomCornerRoomFilledSVG);
export const RoomCourtyardViewFilledIcon = withIconProps(RoomCourtyardViewFilledSVG);
export const RoomDesignatedSmokingAreFilledIcon = withIconProps(RoomDesignatedSmokingAreFilledSVG);
export const RoomDoorFilledIcon = withIconProps(RoomDoorFilledSVG);
export const RoomFireplaceFilledIcon = withIconProps(RoomFireplaceFilledSVG);
export const RoomFireworksViewFilledIcon = withIconProps(RoomFireworksViewFilledSVG);
export const RoomFlowerGardenViewFilledIcon = withIconProps(RoomFlowerGardenViewFilledSVG);
export const RoomFlowerGardenViewRiverViewFilledIcon = withIconProps(
  RoomFlowerGardenViewRiverViewFilledSVG,
);
export const RoomForestViewFilledIcon = withIconProps(RoomForestViewFilledSVG);
export const RoomGardenViewFilledIcon = withIconProps(RoomGardenViewFilledSVG);
export const RoomGolfCourseViewFilledIcon = withIconProps(RoomGolfCourseViewFilledSVG);
export const RoomHarborViewFilledIcon = withIconProps(RoomHarborViewFilledSVG);
export const RoomHillSideViewFilledIcon = withIconProps(RoomHillSideViewFilledSVG);
export const RoomJetBathFilledIcon = withIconProps(RoomJetBathFilledSVG);
export const RoomKitchenFilledIcon = withIconProps(RoomKitchenFilledSVG);
export const RoomLakeViewFilledIcon = withIconProps(RoomLakeViewFilledSVG);
export const RoomLivingRoomFilledIcon = withIconProps(RoomLivingRoomFilledSVG);
export const RoomMapleViewFilledIcon = withIconProps(RoomMapleViewFilledSVG);
export const RoomMountFujiViewFilledIcon = withIconProps(RoomMountFujiViewFilledSVG);
export const RoomMountainViewFilledIcon = withIconProps(RoomMountainViewFilledSVG);
export const RoomNightlifeViewFilledIcon = withIconProps(RoomNightlifeViewFilledSVG);
export const RoomNoSmokingFilledIcon = withIconProps(RoomNoSmokingFilledSVG);
export const RoomOceanViewCoralSeaViewFilledIcon = withIconProps(
  RoomOceanViewCoralSeaViewFilledSVG,
);
export const RoomPalaceViewFilledIcon = withIconProps(RoomPalaceViewFilledSVG);
export const RoomPanoramicViewFilledIcon = withIconProps(RoomPanoramicViewFilledSVG);
export const RoomParkViewFilledIcon = withIconProps(RoomParkViewFilledSVG);
export const RoomPoolViewOutlineIcon = withIconProps(RoomPoolViewOutlineSVG);
export const RoomRenovatedRoomFilledIcon = withIconProps(RoomRenovatedRoomFilledSVG);
export const RoomSeparateBathToiletFilledIcon = withIconProps(RoomSeparateBathToiletFilledSVG);
export const RoomSharedRoomFilledIcon = withIconProps(RoomSharedRoomFilledSVG);
export const RoomShowerOnlyFilledIcon = withIconProps(RoomShowerOnlyFilledSVG);
export const RoomShowerToiletFilledIcon = withIconProps(RoomShowerToiletFilledSVG);
export const RoomSizeFilledIcon = withIconProps(RoomSizeFilledSVG);
export const RoomSmokingFilledIcon = withIconProps(RoomSmokingFilledSVG);
export const RoomSmokingOrNoFilledIcon = withIconProps(RoomSmokingOrNoFilledSVG);
export const RoomTatamiFilledIcon = withIconProps(RoomTatamiFilledSVG);
export const RoomToiletBathroomFilledIcon = withIconProps(RoomToiletBathroomFilledSVG);
export const RoomTokyoTowerViewFilledIcon = withIconProps(RoomTokyoTowerViewFilledSVG);
export const RoomUpgradeFilledIcon = withIconProps(RoomUpgradeFilledSVG);
export const RoomViewChosenByHotelFilledIcon = withIconProps(RoomViewChosenByHotelFilledSVG);
export const RoomWindowFilledIcon = withIconProps(RoomWindowFilledSVG);
export const Rotate2FilledIcon = withIconProps(Rotate2FilledSVG);
export const RotateFilledIcon = withIconProps(RotateFilledSVG);
export const SakuraFilledIcon = withIconProps(SakuraFilledSVG);
export const SaveRexFilledIcon = withIconProps(SaveRexFilledSVG);
export const SaveRexOutlineIcon = withIconProps(SaveRexOutlineSVG);
export const SearchFilledIcon = withIconProps(SearchFilledSVG);
export const SearchHistoryRexFilledIcon = withIconProps(SearchHistoryRexFilledSVG);
export const SearchHistoryRexOutlineIcon = withIconProps(SearchHistoryRexOutlineSVG);
export const SendRaiFilledIcon = withIconProps(SendRaiFilledSVG);
export const SendRaiOutlineIcon = withIconProps(SendRaiOutlineSVG);
export const SendRexFilledIcon = withIconProps(SendRexFilledSVG);
export const SendRexOutlineIcon = withIconProps(SendRexOutlineSVG);
export const SettingsRexFilledIcon = withIconProps(SettingsRexFilledSVG);
export const SettingsRexOutlineIcon = withIconProps(SettingsRexOutlineSVG);
export const ShareFilledIcon = withIconProps(ShareFilledSVG);
export const ShareRexFilledIcon = withIconProps(ShareRexFilledSVG);
export const ShareRexOutlineIcon = withIconProps(ShareRexOutlineSVG);
export const ShineFilledIcon = withIconProps(ShineFilledSVG);
export const ShowRexFilledIcon = withIconProps(ShowRexFilledSVG);
export const ShowRexOutlineIcon = withIconProps(ShowRexOutlineSVG);
export const SliderRexFilledIcon = withIconProps(SliderRexFilledSVG);
export const SliderRexOutlineIcon = withIconProps(SliderRexOutlineSVG);
export const SnowmanFilledIcon = withIconProps(SnowmanFilledSVG);
export const SnsFacebookGrayFilledIcon = withIconProps(SnsFacebookGrayFilledSVG);
export const SnsFacebookNewFilledIcon = withIconProps(SnsFacebookNewFilledSVG);
export const SnsFacebookOldFilledIcon = withIconProps(SnsFacebookOldFilledSVG);
export const SnsGooglemapFilledIcon = withIconProps(SnsGooglemapFilledSVG);
export const SnsInstagramNewFilledIcon = withIconProps(SnsInstagramNewFilledSVG);
export const SnsInstagramOutlineIcon = withIconProps(SnsInstagramOutlineSVG);
export const SnsInstagramSolidIcon = withIconProps(SnsInstagramSolidSVG);
export const SnsLineFilledIcon = withIconProps(SnsLineFilledSVG);
export const SnsNoteFilledIcon = withIconProps(SnsNoteFilledSVG);
export const SnsRakutenRoomFilledIcon = withIconProps(SnsRakutenRoomFilledSVG);
export const SnsTiktokFilledIcon = withIconProps(SnsTiktokFilledSVG);
export const SnsViberFilledIcon = withIconProps(SnsViberFilledSVG);
export const SnsWhatsAppFilledIcon = withIconProps(SnsWhatsAppFilledSVG);
export const SnsXFrameFilledIcon = withIconProps(SnsXFrameFilledSVG);
export const SnsXOutlineIcon = withIconProps(SnsXOutlineSVG);
export const SnsYoutubeFilledIcon = withIconProps(SnsYoutubeFilledSVG);
export const SortArrowFilledIcon = withIconProps(SortArrowFilledSVG);
export const StarRexFilledIcon = withIconProps(StarRexFilledSVG);
export const StarRexOutlineIcon = withIconProps(StarRexOutlineSVG);
export const StopFilledIcon = withIconProps(StopFilledSVG);
export const SubtractIcon = withIconProps(SubtractIconSVG);
export const SuccessFilledIcon = withIconProps(SuccessFilledSVG);
export const SuccessColoredOutlinedIcon = withIconProps(SuccessColoredOutlinedSVG);

export const SuitcaseFilledIcon = withIconProps(SuitcaseFilledSVG);
export const SuitcaseOutlineIcon = withIconProps(SuitcaseOutlineSVG);
export const SummerVacationFilledIcon = withIconProps(SummerVacationFilledSVG);
export const SunFilledIcon = withIconProps(SunFilledSVG);
export const SurveyRexFilledIcon = withIconProps(SurveyRexFilledSVG);
export const SurveyRexOutlineIcon = withIconProps(SurveyRexOutlineSVG);
export const SustainabilityRexFilledIcon = withIconProps(SustainabilityRexFilledSVG);
export const SustainabilityRexOutlineIcon = withIconProps(SustainabilityRexOutlineSVG);
export const TabletRexFilledIcon = withIconProps(TabletRexFilledSVG);
export const TabletRexOutlineIcon = withIconProps(TabletRexOutlineSVG);
export const TargetFilledIcon = withIconProps(TargetFilledSVG);
export const TargetRexFilledIcon = withIconProps(TargetRexFilledSVG);
export const TargetRexOutlineIcon = withIconProps(TargetRexOutlineSVG);
export const Time24HourFilledIcon = withIconProps(Time24HourFilledSVG);
export const TimeCheckInFilledIcon = withIconProps(TimeCheckInFilledSVG);
export const TimeCheckOutFilledIcon = withIconProps(TimeCheckOutFilledSVG);
export const TimeClockFilledIcon = withIconProps(TimeClockFilledSVG);
export const TimeClockOutlineIcon = withIconProps(TimeClockOutlineSVG);
export const TimeTimerFilledIcon = withIconProps(TimeTimerFilledSVG);
export const TimeWaitFilledIcon = withIconProps(TimeWaitFilledSVG);
export const TransportationAirplane2FilledIcon = withIconProps(TransportationAirplane2FilledSVG);
export const TransportationAirplaneOutlineIcon = withIconProps(TransportationAirplaneOutlineSVG);
export const TransportationAirportShuttleBusFilledIcon = withIconProps(
  TransportationAirportShuttleBusFilledSVG,
);
export const TransportationBusFilledIcon = withIconProps(TransportationBusFilledSVG);
export const TransportationBusRexFilledIcon = withIconProps(TransportationBusRexFilledSVG);
export const TransportationBusRexOutlineIcon = withIconProps(TransportationBusRexOutlineSVG);
export const TransportationBusStopFilledIcon = withIconProps(TransportationBusStopFilledSVG);
export const TransportationCarFrontRexFilledIcon = withIconProps(
  TransportationCarFrontRexFilledSVG,
);
export const TransportationCarFrontRexOutlineIcon = withIconProps(
  TransportationCarFrontRexOutlineSVG,
);
export const TransportationCarSideFilledIcon = withIconProps(TransportationCarSideFilledSVG);
export const TransportationDropoffFilledIcon = withIconProps(TransportationDropoffFilledSVG);
export const TransportationFerryBoatFilledIcon = withIconProps(TransportationFerryBoatFilledSVG);
export const TransportationFerryRexFilledIcon = withIconProps(TransportationFerryRexFilledSVG);
export const TransportationFerryRexOutlineIcon = withIconProps(TransportationFerryRexOutlineSVG);
export const TransportationShuttleBusFilledIcon = withIconProps(TransportationShuttleBusFilledSVG);
export const TransportationTrainFilledIcon = withIconProps(TransportationTrainFilledSVG);
export const TransportationTruckRexFilledIcon = withIconProps(TransportationTruckRexFilledSVG);
export const TransportationTruckRexOutlineIcon = withIconProps(TransportationTruckRexOutlineSVG);
export const TransportationWalkingFilledIcon = withIconProps(TransportationWalkingFilledSVG);
export const TravelInsuranceFilledIcon = withIconProps(TravelInsuranceFilledSVG);
export const UploadRexFilledIcon = withIconProps(UploadRexFilledSVG);
export const UploadRexOutlineIcon = withIconProps(UploadRexOutlineSVG);
export const UserReviewFilledIcon = withIconProps(UserReviewFilledSVG);
export const VerticalDotsFilledIcon = withIconProps(VerticalDotsFilledSVG);
export const VideoFilledIcon = withIconProps(VideoFilledSVG);
export const VoiceInputRexFilledIcon = withIconProps(VoiceInputRexFilledSVG);
export const VoiceInputRexOutlineIcon = withIconProps(VoiceInputRexOutlineSVG);
export const VolumeFilledIcon = withIconProps(VolumeFilledSVG);
export const VolumeSilentFilledIcon = withIconProps(VolumeSilentFilledSVG);
export const WaterDropFilledIcon = withIconProps(WaterDropFilledSVG);
export const WinterVacationFilledIcon = withIconProps(WinterVacationFilledSVG);
export const WorldRexFilledIcon = withIconProps(WorldRexFilledSVG);
export const WorldRexOutlineIcon = withIconProps(WorldRexOutlineSVG);
export const WarningGreyFilledIcon = withIconProps(WarningGreyFilledSVG);
export const YenCoinOutlineIcon = withIconProps(YenCoinOutlineSVG);
export const YenEnFilledIcon = withIconProps(YenEnFilledSVG);
export const YenJpFilledIcon = withIconProps(YenJpFilledSVG);
export const ZipRexFilledIcon = withIconProps(ZipRexFilledSVG);
export const ZipRexOutlineIcon = withIconProps(ZipRexOutlineSVG);
export const ZoomInRexFilledIcon = withIconProps(ZoomInRexFilledSVG);
export const ZoomInRexOutlineIcon = withIconProps(ZoomInRexOutlineSVG);
export const ZoomOutRexFilledIcon = withIconProps(ZoomOutRexFilledSVG);
export const ZoomOutRexOutlineIcon = withIconProps(ZoomOutRexOutlineSVG);
